(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7197],{

/***/ 74669:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homepage/solutions/solution-page",
      function () {
        return __webpack_require__(6946);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowLeft = function SvgArrowLeft(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 14,
        viewBox: "0 0 8 14"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#333",
        d: "M7.687 12.045 2.574 6.933l5.113-5.112A1.065 1.065 0 1 0 6.18.312L.313 6.18a1.064 1.064 0 0 0 0 1.508l5.867 5.867a1.065 1.065 0 1 0 1.507-1.508"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowLeft);


/***/ }),

/***/ 39055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgEarth = function SvgEarth(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
    })), _path2 || (_path2 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.831 18.737C6.613 16.95 5.8 13.707 5.8 10s.813-6.951 2.031-8.737M1 10h18M2.386 14.8h15.229M2.386 5.2h15.229M12.169 1.263C13.386 3.05 14.2 6.293 14.2 10s-.813 6.951-2.031 8.737"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgEarth);


/***/ }),

/***/ 61167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G8": function() { return /* binding */ HEADER_POPUP_OPTIONS; },
/* harmony export */   "Yq": function() { return /* binding */ HEADER_POPUP_DATA; }
/* harmony export */ });
/* unused harmony exports RING_THE_BELL_VALUE, IPO_BLOG_POST_VALUE, ELEVATE_REGISTRATION_VALUE, RING_THE_BELL_TEXT, IPO_BLOG_POST_TEXT, ELEVATE_REGISTRATION_TEXT */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var constants_links__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27639);
/* harmony import */ var constants_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72632);
/* harmony import */ var constants_localization__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constants_localization__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(861);




var RING_THE_BELL_VALUE = "ring_the_bell";
var IPO_BLOG_POST_VALUE = "ipo_blog_post";
var ELEVATE_REGISTRATION_VALUE = "elevate_registration";
var RING_THE_BELL_TEXT = "Ring the bell";
var IPO_BLOG_POST_TEXT = "IPO blog post";
var ELEVATE_REGISTRATION_TEXT = "Elevate Registration";
var HEADER_POPUP_OPTIONS = [
    {
        value: RING_THE_BELL_VALUE,
        text: RING_THE_BELL_TEXT
    },
    {
        value: IPO_BLOG_POST_VALUE,
        text: IPO_BLOG_POST_TEXT
    },
    {
        value: ELEVATE_REGISTRATION_VALUE,
        text: ELEVATE_REGISTRATION_TEXT
    }
];
var CLOUDINARY_BELL_GIF_SRC = "https://dapulse-res.cloudinary.com/image/upload/q_auto/mondayhomepage/ipo/ipo-bell-gif.gif";
var ELEVATE_GIF_SRC = "https://dapulse-res.cloudinary.com/image/upload/q_auto/mondayhomepage/elevate/star-rect.gif";
var ELEVATE_MOBILE_IMAGE_SRC = "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/mondayhomepage/elevate/star-static.png";
var getRingTheBellLink = function() {
    return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .RING_THE_BELL_VIDEO_LINK */ .Kk$;
};
var getIpoBlogPostLink = function(locale) {
    switch(locale){
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.SPANISH_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_SPANISH_LINK */ .zjT;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.PORTUGEESE_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_PORTUGESE_LINK */ .aL4;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.GERMAN_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_GERMAN_LINK */ .mF0;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.FRENCH_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_FRENCH_LINK */ .div;
        default:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_LINK */ .vWk;
    }
};
var getElevateRegitrationLink = function() {
    return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ELEVATE_MAIN_PAGE_LINK */ .Csm;
};
var _obj;
var HEADER_POPUP_DATA = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, RING_THE_BELL_VALUE, {
    textKey: "header.ipo.popup.ringTheBell.mainText",
    ctaKey: "header.ipo.popup.ringTheBell.cta",
    getLink: getRingTheBellLink,
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .PURPLE_THEME_ID */ .qF,
    gifSrc: CLOUDINARY_BELL_GIF_SRC
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, IPO_BLOG_POST_VALUE, {
    textKey: "header.ipo.popup.ipoBlogPost.mainText",
    ctaKey: "header.ipo.popup.ipoBlogPost.cta",
    getLink: getIpoBlogPostLink,
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .PURPLE_THEME_ID */ .qF,
    gifSrc: CLOUDINARY_BELL_GIF_SRC
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, ELEVATE_REGISTRATION_VALUE, {
    textKey: "header.elevate.popup.mainText",
    mobileTextKey: "header.elevate.popup.mobileText",
    ctaKey: "header.elevate.popup.cta",
    getLink: getElevateRegitrationLink,
    popupClassName: "elevate",
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .GRADIANT_ELEVATE_THEME_ID */ .wk,
    gifSrc: ELEVATE_GIF_SRC,
    mobileImageSrc: ELEVATE_MOBILE_IMAGE_SRC
}), _obj);


/***/ }),

/***/ 68830:
/***/ (function(module) {

"use strict";

var SINGLE_SOLUTION_PAGE_TYPE = "SingleSolution";
var SOLUTIONS_IN_CATEGORY_PAGE_TYPE = "categorySolutions";
var SOLUTIONS_HOME_PAGE_TYPE = "Home";
var SOLUTIONS_SEARCH_PAGE_TYPE = "Search";
module.exports = {
    SINGLE_SOLUTION_PAGE_TYPE: SINGLE_SOLUTION_PAGE_TYPE,
    SOLUTIONS_IN_CATEGORY_PAGE_TYPE: SOLUTIONS_IN_CATEGORY_PAGE_TYPE,
    SOLUTIONS_HOME_PAGE_TYPE: SOLUTIONS_HOME_PAGE_TYPE,
    SOLUTIONS_SEARCH_PAGE_TYPE: SOLUTIONS_SEARCH_PAGE_TYPE
};


/***/ }),

/***/ 79813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ BaseTemplatePage; },
/* harmony export */   "getSerializedServerProps": function() { return /* binding */ getSerializedServerProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24730);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75422);
/* harmony import */ var server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4__);









var isObject = function(obj) {
    return obj && typeof obj === "object";
};
var __N_SSP = true;
var getSerializedServerProps = function(serverProps) {
    return Object.keys(serverProps).reduce(function(result, prop) {
        if (isObject(serverProps[prop])) {
            var objectKeys = Object.keys(serverProps[prop]);
            for(var i = 0; i < objectKeys.length; i++){
                var key = objectKeys[i];
                if (serverProps[prop][key] === undefined) {
                    delete serverProps[prop][key];
                }
            }
        }
        if (serverProps[prop]) {
            result[prop] = serverProps[prop];
        }
        return result;
    }, {});
};
var BaseTemplatePage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(BaseTemplatePage, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(BaseTemplatePage);
    function BaseTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, BaseTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(BaseTemplatePage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pageConfig = this.props.pageConfig;
                // Track ab test if the landing page is in test.
                if (pageConfig && pageConfig.abTestVariant && pageConfig.abTestName) {
                    BigBrain("track", pageConfig.abTestName, {
                        ab_test: pageConfig.abTestVariant
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    statusCode: errorCode
                });
            }
        }
    ]);
    return BaseTemplatePage;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 6946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ SolutionPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(12918);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/templates/base-template.js + 57 modules
var base_template = __webpack_require__(81620);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.js + 81 modules
var base_header_component = __webpack_require__(33782);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js + 1 modules
var long_footer_component = __webpack_require__(55408);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/icons/Search.js
var Search = __webpack_require__(81759);
var Search_default = /*#__PURE__*/__webpack_require__.n(Search);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/icons/CloseSmall.js
var CloseSmall = __webpack_require__(16476);
var CloseSmall_default = /*#__PURE__*/__webpack_require__.n(CloseSmall);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./template-store/constants/categories.js
var constants_categories = __webpack_require__(62494);
var categories_default = /*#__PURE__*/__webpack_require__.n(constants_categories);
// EXTERNAL MODULE: ./node_modules/url-join/lib/url-join.js
var url_join = __webpack_require__(34078);
var url_join_default = /*#__PURE__*/__webpack_require__.n(url_join);
;// CONCATENATED MODULE: ./template-store/services/solution-categories-service.js



var DEFAULT_DEMO_CLOUDINARY_ROOT_FOLDER = "https://dapulse-res.cloudinary.com/video/upload/mondayhomepage/template-store/feature_videos/";
var _obj;
var CATEGORY_DEMO_VIDEOS_FOLDER = (_obj = {}, (0,_define_property/* default */.Z)(_obj, (categories_default()).MARKETING, "marketing"), (0,_define_property/* default */.Z)(_obj, (categories_default()).PROJECT_MANAGEMENT, "project_management"), (0,_define_property/* default */.Z)(_obj, (categories_default()).CRM, "crm"), (0,_define_property/* default */.Z)(_obj, (categories_default()).SOFTWARE_DEVELOPMENT, "software_development"), (0,_define_property/* default */.Z)(_obj, (categories_default()).HR, "hr"), (0,_define_property/* default */.Z)(_obj, (categories_default()).DESIGN, "design"), (0,_define_property/* default */.Z)(_obj, (categories_default()).CONTENT_PRODUCTION, "content_production"), (0,_define_property/* default */.Z)(_obj, (categories_default()).FREELANCERS, "freelancers"), (0,_define_property/* default */.Z)(_obj, (categories_default()).OPERATIONS, "office_operations"), (0,_define_property/* default */.Z)(_obj, (categories_default()).STARTUP, "startup"), (0,_define_property/* default */.Z)(_obj, (categories_default()).EDUCATION, "education"), (0,_define_property/* default */.Z)(_obj, (categories_default()).REAL_ESTATE, "real_estate"), (0,_define_property/* default */.Z)(_obj, (categories_default()).CONSTRUCTION, "construction"), _obj);
var getCategoryData = function(categories, categoryId) {
    return categories.find(function(category) {
        return category.value === categoryId;
    });
};
var getCategoriesData = function(categories, categoryIds) {
    return categories.filter(function(category) {
        return categoryIds === null || categoryIds === void 0 ? void 0 : categoryIds.includes(category.value);
    });
};
var getFeaturedCategories = function(categories) {
    var featuredCategoriesIds = [
        (categories_default()).MARKETING,
        (categories_default()).PROJECT_MANAGEMENT,
        (categories_default()).CRM,
        (categories_default()).SOFTWARE_DEVELOPMENT,
        (categories_default()).HR,
        (categories_default()).DESIGN
    ];
    return categories.filter(function(category) {
        return featuredCategoriesIds.includes(category.value);
    });
};
var getBannerDescriptionKeyForCategory = function(category_id) {
    return "templateCenter.category.description.".concat(category_id);
};
var getBannerTitleKeyForCategory = function(category_id) {
    return "templateCenter.category.title.".concat(category_id);
};
var getCategoryName = function(categoryData) {
    return categoryData === null || categoryData === void 0 ? void 0 : categoryData.label;
};
var getCategoryId = function(categoryData) {
    return categoryData === null || categoryData === void 0 ? void 0 : categoryData.value;
};
var getCloudinartDemoVideoURLForCategory = function(categoryId, fileName) {
    var rootFolder = DEFAULT_DEMO_CLOUDINARY_ROOT_FOLDER;
    var categoryFolder = CATEGORY_DEMO_VIDEOS_FOLDER[categoryId];
    if (!!categoryFolder) {
        rootFolder = url_join_default()(rootFolder, categoryFolder);
    }
    return url_join_default()(rootFolder, fileName);
};

;// CONCATENATED MODULE: ./template-store/services/solution-links-service.js

var ROOT_DIR = "templates";
var getSolutionPageLink = function(solutionId, solutionEnglishName) {
    var normalizedName = solutionEnglishName.replace(/ /g, "-").toLowerCase(); // replaceAll not supported in node 10
    return "/".concat(ROOT_DIR, "/template/").concat(solutionId, "/").concat(normalizedName);
};
var getSolutionCategoryPageLink = function(categoryId) {
    if (categoryId === constants_categories.HOME_ID) return getSolutionsHomeLink();
    return "/".concat(ROOT_DIR, "/category/").concat(categoryId);
};
var getSolutionSearchLink = function(searchTerm) {
    return "/".concat(ROOT_DIR, "/search?term=").concat(searchTerm);
};
var getSolutionsHomeLink = function() {
    return "/".concat(ROOT_DIR);
};

// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/icons/Favorite.js
var Favorite = __webpack_require__(51132);
var Favorite_default = /*#__PURE__*/__webpack_require__.n(Favorite);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./template-store/components/navigation/menu-component/menu-component.scss.js

var COLORS = {
    hover: "#e6e9ef",
    selectedBackground: "#cce5ff",
    selectedText: "#0073ea"
};
var StyledMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e92b6gb0"
})("display:flex;flex-direction:column;width:240px;a{text-decoration:none;color:inherit;.menu-item{display:flex;padding:4px 8px;cursor:pointer;line-height:26px;border-radius:4px;font-size:0.875rem;border:1px solid transparent;.star-icon-wrapper{padding-right:4px;display:flex;align-items:center;svg{max-height:20px;padding-bottom:2px;}}}.menu-item:hover{background-color:", COLORS.hover, ";}.menu-item.selected{background-color:", COLORS.selectedBackground, ";color:", COLORS.selectedText, ";}}");

// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./template-store/components/navigation/menu-component/menu-component.js











var MenuComponent = function(param) {
    var allCategories = param.allCategories, selectedCategoryId = param.selectedCategoryId;
    var ref = (0,react.useState)(null), selectedItem = ref[0], setSelectedItem = ref[1];
    (0,react.useEffect)(function() {
        // Get the last word from the current URL
        var lastWordFromURL = (0,url.getLastPartOfUrl)(window.location.pathname);
        // Check if the last word exists
        if (lastWordFromURL) {
            setSelectedItem(lastWordFromURL);
        }
    }, []);
    var navigationItemClicked = function(id) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.MENU_CATEGORY_CLICKED, {
            kind: id
        });
    };
    var handleItemClick = function(item, id) {
        navigationItemClicked(id);
    };
    var categories = allCategories.map(function(categoryData, index) {
        var id = getCategoryId(categoryData);
        var link = getSolutionCategoryPageLink(id);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: link,
            onClick: function() {
                return handleItemClick(id, link);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("menu-item", {
                    selected: selectedItem === categoryData.value
                }),
                children: categoryData.label
            }, index)
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMenuComponent, {
        className: "menu-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: getSolutionsHomeLink(),
                onClick: function() {
                    return handleItemClick(constants_categories.HOME_ID, getSolutionsHomeLink());
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("menu-item", {
                        selected: selectedItem && selectedCategoryId === constants_categories.HOME_ID
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "star-icon-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Favorite_default()), {})
                        }),
                        "Featured"
                    ]
                })
            }),
            categories
        ]
    });
};
/* harmony default export */ var menu_component = (MenuComponent);

// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/Search.css
var dist_Search = __webpack_require__(47780);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/Menu.css
var Menu = __webpack_require__(41481);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/MenuItem.css
var MenuItem = __webpack_require__(90701);
;// CONCATENATED MODULE: ./template-store/components/navigation/navigation-component.scss.js




var StyledTemplatesNavigation = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1d5crmc0"
})(".search-wrapper{width:240px;}.category-list-wrapper{margin-top:20px;.template-store-category-menu{.monday-style-menu-item{line-height:26px;}}}.search-wrapper{height:40px;}");

;// CONCATENATED MODULE: ./template-store/components/navigation/navigation-component.js










var navigation_component_Search = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3044).then(__webpack_require__.t.bind(__webpack_require__, 23044, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23044)
            ];
        }
    },
    ssr: false
});
var TemplatesNavigation = function(props) {
    var onSearchChange = props.onSearchChange, searchTerm = props.searchTerm, translate = props.translate, allCategories = props.allCategories, selectedCategoryId = props.selectedCategoryId;
    var ref = (0,react.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    (0,react.useEffect)(function() {
        setIsLoaded(true);
    }, []);
    var onSearchBlur = (0,react.useCallback)(function(e) {
        var _e_target;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SOLUTION_STORE_SEARCH_COMPLETED, {
            kind: e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTemplatesNavigation, {
        className: "navigation-component",
        children: isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "search-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_component_Search, {
                        placeholder: translate("templateCenter.template.search"),
                        onChange: onSearchChange,
                        value: searchTerm,
                        iconName: (Search_default()),
                        secondaryIconName: (CloseSmall_default()),
                        onBlur: onSearchBlur
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "category-list-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_component, {
                        allCategories: allCategories,
                        selectedCategoryId: selectedCategoryId
                    })
                })
            ]
        })
    });
};
TemplatesNavigation.defaultProps = {
    onSearchChange: function() {}
};
/* harmony default export */ var navigation_component = ((0,generic_config_context/* withGenericConfig */.P)(TemplatesNavigation));

// EXTERNAL MODULE: ./constants/template-center/solution-page-types.js
var solution_page_types = __webpack_require__(68830);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js + 1 modules
var regular_button = __webpack_require__(35662);
// EXTERNAL MODULE: ./node_modules/@mondaydotcomorg/monday-ui-components/dist/Tag.js
var Tag = __webpack_require__(62554);
var Tag_default = /*#__PURE__*/__webpack_require__.n(Tag);
// EXTERNAL MODULE: ./node_modules/@mondaydotcomorg/monday-ui-components/dist/Tag.css
var dist_Tag = __webpack_require__(74998);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./template-store/components/template-header/template-header.scss.js



var StyledTemplateHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e418c200"
})('display:flex;.template-data-wrapper{display:flex;flex-direction:column;line-height:30px;justify-content:center;.template-name{font-size:1.375rem;font-weight:700;}.template-details-wrapper{margin-top:6px;.template-categories{display:flex;font-size:0.8125rem;.categories-wrapper{display:flex;margin-left:4px;.category-wrapper{display:flex;&:not(:last-child){&::after{content:",";}margin-right:4px;}}}}}}@media (max-width:', vp_sizes/* TABLET_QUERY_MIN_WIDTH */.Al, "){.template-data-wrapper{.template-details-wrapper{margin-top:2px;}}}");

;// CONCATENATED MODULE: ./template-store/components/template-header/template-header.js




var TemplateHeader = function(props) {
    var templateName = props.templateName, templateCategoriesData = props.templateCategoriesData, categoriesPrefixText = props.categoriesPrefixText;
    var renderCategories = function() {
        return templateCategoriesData.map(function(categoryData, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "category-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Tag_default()), {
                    tagName: categoryData.label,
                    tagLink: getSolutionCategoryPageLink(categoryData.value)
                })
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTemplateHeader, {
        className: "template-header",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "template-data-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    className: "template-name",
                    children: [
                        " ",
                        templateName,
                        " Template"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "template-details-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "template-categories",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "category-prefix-text",
                                children: categoriesPrefixText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "categories-wrapper",
                                children: [
                                    " ",
                                    renderCategories()
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
TemplateHeader.defaultProps = {};
/* harmony default export */ var template_header = (TemplateHeader);

// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./components/core/tabs/tabs-component.js + 1 modules
var tabs_component = __webpack_require__(10873);
// EXTERNAL MODULE: ./components/core/tabs/tab/tab-component.js + 1 modules
var tab_component = __webpack_require__(20525);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
;// CONCATENATED MODULE: ./template-store/components/paragraph-with-video/paragraph-with-video.scss.js

var StyledParagraphWithVideo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1rnlpr80"
})("display:flex;flex-direction:column;width:100%;.paragraph-content-title{font-size:1rem;font-weight:700;line-height:30px;margin-bottom:24px;}.paragraph-content-description{font-size:0.875rem;line-height:24px;}.paragraph-video-wrapper{margin-top:40px;.pargraph-video-item{width:100%;}}");

;// CONCATENATED MODULE: ./template-store/components/paragraph-with-video/paragraph-with-video.js


var ParagraphWithVideo = function(props) {
    var title = props.title, description = props.description, videoSrc = props.videoSrc;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledParagraphWithVideo, {
        className: "paragraph-with-video",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "paragraph-content-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "paragraph-content-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "paragraph-content-description",
                        children: description
                    })
                ]
            }),
            videoSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "paragraph-video-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    className: "pargraph-video-item",
                    src: videoSrc,
                    loop: "true",
                    muted: "true",
                    autoplay: "true"
                })
            })
        ]
    });
};
/* harmony default export */ var paragraph_with_video = (ParagraphWithVideo);

;// CONCATENATED MODULE: ./template-store/components/paragraph-with-demo/paragraph-with-demo-component.scss.js

var StyledParagraphWithDemoComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ej6mo0r0"
})("display:flex;flex-direction:column;width:100%;.paragraph-demo-wrapper{margin-top:48px;}.paragraph-content-title{font-size:1rem;font-weight:700;line-height:30px;margin-bottom:24px;}.paragraph-content-description-wrapper{display:flex;.paragraph-content-icon{margin-right:16px;}.paragraph-content-description{font-size:0.875rem;line-height:24px;flex-grow:1;}}");

;// CONCATENATED MODULE: ./template-store/components/paragraph-with-demo/paragraph-with-demo-component.js



var ParagraphWithDemoComponent = function(param) {
    var title = param.title, description = param.description, translate = param.translate, Icon = param.icon, DemoComponent = param.demoComponent, demoComponentMetadata = param.demoComponentMetadata, templateData = param.templateData, templateDataFieldName = param.templateDataFieldName;
    var shouldHideComponent = function() {
        return templateDataFieldName && !templateData[templateDataFieldName];
    };
    return shouldHideComponent() ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledParagraphWithDemoComponent, {
        className: "paragraph-with-demo",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "paragraph-content-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "paragraph-content-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "paragraph-content-description-wrapper",
                        children: [
                            Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "paragraph-content-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "paragraph-content-description",
                                children: description
                            })
                        ]
                    })
                ]
            }),
            DemoComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "paragraph-demo-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DemoComponent, {
                    translate: translate,
                    metadata: demoComponentMetadata,
                    templateData: templateData
                })
            })
        ]
    });
};
/* harmony default export */ var paragraph_with_demo_component = ((0,generic_config_context/* withGenericConfig */.P)(ParagraphWithDemoComponent));

;// CONCATENATED MODULE: ./template-store/services/solution-data-service.js
var SOLUTION_TO_CANONICAL_URL_MAPPING = {
    "113127": "https://monday.com/templates/content-planning"
};
var getSolutionThumbnail = function(solutionData) {
    var _solutionData_images_;
    return (solutionData === null || solutionData === void 0 ? void 0 : solutionData.thumbnailUrl) || (solutionData === null || solutionData === void 0 ? void 0 : solutionData.images) && (solutionData === null || solutionData === void 0 ? void 0 : (_solutionData_images_ = solutionData.images[0]) === null || _solutionData_images_ === void 0 ? void 0 : _solutionData_images_.url);
};
var getSolutionName = function(solutionData) {
    return solutionData === null || solutionData === void 0 ? void 0 : solutionData.name;
};
var getSolutionDescription = function(solutionData) {
    return solutionData === null || solutionData === void 0 ? void 0 : solutionData.description;
};
var getSolutionShortDescription = function(solutionData) {
    return (solutionData === null || solutionData === void 0 ? void 0 : solutionData.shortDescription) || (solutionData === null || solutionData === void 0 ? void 0 : solutionData.description);
};
var getSolutionEnglishName = function(solution) {
    //Takes the not translated solution name not from the solution data
    return (solution === null || solution === void 0 ? void 0 : solution.name) || getSolutionName(solution === null || solution === void 0 ? void 0 : solution.data);
};
var getSolutionId = function(solution) {
    // using app_feature_reference_id since it doesn't change and id can change with new versions
    return (solution === null || solution === void 0 ? void 0 : solution.app_feature_reference_id) || (solution === null || solution === void 0 ? void 0 : solution.id);
};
var getSolutionCategoryIds = function(solutionData) {
    return (solutionData === null || solutionData === void 0 ? void 0 : solutionData.categories) || [];
};

;// CONCATENATED MODULE: ./template-store/components/template-feature-content/template-feature-content.scss.js

var StyledTemplateFeatureContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1txfj420"
})("width:100%;max-width:720px;.demo-component-wrapper{margin-top:48px;}");

;// CONCATENATED MODULE: ./static/svg/templates-store/bulb.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgBulb = function SvgBulb(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 31,
        height: 31,
        fill: "none",
        viewBox: "0 0 31 31"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#676879",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.385,
        d: "M13.856 26.307h3.286M22.072 15.5a6.571 6.571 0 1 0-8.214 6.339v1.875h3.285v-1.875a6.556 6.556 0 0 0 4.929-6.34M15.5 5.643V4M25.357 13.857H27M4 15.5h1.643M7.366 6.545l1.162 1.162M22.469 7.707l1.162-1.162"
    })));
};
/* harmony default export */ var bulb = (SvgBulb);

;// CONCATENATED MODULE: ./template-store/components/template-feature-content/template-feature-content.js









var TemplateFeatureContent = function(props) {
    var templateData = props.templateData, translate = props.translate, featureTitleKey = props.featureTitleKey, featureDescriptionKey = props.featureDescriptionKey, subsectionTitleKey = props.subsectionTitleKey, subsectionDescriptionKey = props.subsectionDescriptionKey, demoComponent = props.demoComponent, demoComponentMetadata = props.demoComponentMetadata, templateDataFieldName = props.templateDataFieldName, demoVideoFileName = props.demoVideoFileName;
    var videoSrc = (0,react.useMemo)(function() {
        var firstCategory = getSolutionCategoryIds(templateData)[0];
        return getCloudinartDemoVideoURLForCategory(firstCategory, demoVideoFileName);
    }, [
        demoVideoFileName,
        templateData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTemplateFeatureContent, {
        className: "template-feature-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "paragraph-with-image-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_with_video, {
                    title: translate(featureTitleKey),
                    description: translate(featureDescriptionKey),
                    videoSrc: videoSrc
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "demo-component-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_with_demo_component, {
                        title: translate(subsectionTitleKey),
                        description: translate(subsectionDescriptionKey),
                        templateData: templateData,
                        icon: bulb,
                        demoComponent: demoComponent,
                        demoComponentMetadata: demoComponentMetadata,
                        templateDataFieldName: templateDataFieldName
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var template_feature_content = ((0,generic_config_context/* withGenericConfig */.P)(TemplateFeatureContent));

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./template-store/components/asset-gallery/asset-gallery.scss.js


var BASIC_IMAGE_RATIO = 1423 / 824; // based on the size of our thumbnail image design guidelines
var MAIN_GALLERY_HEIGHT = 430;
var MAIN_GALLERY_WIDTH = Math.floor(MAIN_GALLERY_HEIGHT * BASIC_IMAGE_RATIO);
var StyledAssetGallery = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1gtwylz0"
})(".asset-gallery{display:flex;height:", MAIN_GALLERY_HEIGHT, "px;.main-asset-wrapper{height:100%;width:", MAIN_GALLERY_WIDTH, "px;padding:20px;display:flex;justify-content:center;align-items:center;background:", colors/* default.riverstone */.Z.riverstone, ";border-radius:4px;flex-grow:1;.main-asset{height:100%;max-width:100%;}}.assets-previews-wrapper{position:relative;margin-left:16px;.previews-container{display:flex;flex-direction:column;overflow:auto;height:100%;&::-webkit-scrollbar{width:4px;}&::-webkit-scrollbar-thumb{background-color:", colors/* default.silver */.Z.silver, ";border-radius:4px;}.preview-asset-wrapper{position:relative;padding:8px;border:2px solid transparent;background:", colors/* default.riverstone */.Z.riverstone, ";display:flex;justify-content:center;align-items:center;cursor:pointer;border-radius:4px;&.selected{border:2px solid #4353ff;box-sizing:border-box;}&:not(:last-child){margin-bottom:8px;}.preview-asset{width:160px;height:90px;object-fit:contain;}.video-thumbnail-icon{position:absolute;bottom:2px;left:2px;height:20px;width:20px;}}}.preview-side-images-bottom-overlay{position:absolute;bottom:0;left:0;width:100%;min-height:80px;pointer-events:none;background:linear-gradient(180deg,rgba(white,0) 0%,rgba(white,1) 100%);background:linear-gradient(180deg,rgba(white,0) 0%,rgba(white,1) 100%);}}}");

;// CONCATENATED MODULE: ./template-store/components/asset-gallery/asset-gallery.js






var ASSET_TYPE_IMAGE = "image";
var ASSET_TYPE_VIDEO = "video";
var VIDEO_PLAY = "video_play";
var VIDEO_PAUSE = "video_pause";
var VIDEO_ENDED = "video_ended";
var PLAY_VIDEO_IMG_SRC = "https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/template-store/template-page/play.png";
var AssetGallery = function(param) {
    var assets = param.assets;
    var ref = (0,react.useState)(false), isScrolledUntilBottom = ref[0], setIsScrolledUntilBottom = ref[1];
    var ref1 = (0,react.useState)(0), selectedAssetIndex = ref1[0], setSelectedAssetIndex = ref1[1];
    var sideGalleryRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var _sideGalleryRef_current;
        var handleScroll = function() {
            var _current = sideGalleryRef.current, offsetHeight = _current.offsetHeight, scrollTop = _current.scrollTop, scrollHeight = _current.scrollHeight;
            var isScrolledToBottom = offsetHeight + scrollTop >= scrollHeight;
            setIsScrolledUntilBottom(isScrolledToBottom);
        };
        (_sideGalleryRef_current = sideGalleryRef.current) === null || _sideGalleryRef_current === void 0 ? void 0 : _sideGalleryRef_current.addEventListener("scroll", handleScroll);
        return function() {
            var _sideGalleryRef_current;
            return (_sideGalleryRef_current = sideGalleryRef.current) === null || _sideGalleryRef_current === void 0 ? void 0 : _sideGalleryRef_current.removeEventListener("scroll", handleScroll);
        };
    }, [
        isScrolledUntilBottom
    ]);
    var selectAsset = (0,react.useCallback)(function(index) {
        var _assets_index;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SOLUTION_GALERY_ITEM_CLICKED, {
            kind: (_assets_index = assets[index]) === null || _assets_index === void 0 ? void 0 : _assets_index.type,
            info1: index,
            info2: assets.length
        });
        setSelectedAssetIndex(index);
    }, [
        assets
    ]);
    /*
    Renderers
  */ var renderSideImagesOverlayIfNeeded = (0,react.useCallback)(function() {
        if (isScrolledUntilBottom) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "preview-side-images-bottom-overlay"
        });
    }, [
        isScrolledUntilBottom
    ]);
    var renderPlayIcon = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            className: "video-thumbnail-icon",
            src: PLAY_VIDEO_IMG_SRC
        });
    };
    var onVideoInteraction = function(asset, actionType) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SOLUTION_GALERY_VIDEO_INTERACTION, {
            kind: actionType,
            info1: asset.src
        });
    };
    var renderAssetIndex = (0,react.useCallback)(function(assetIndex) {
        var isMain = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var className = isMain ? "main-asset" : "preview-asset";
        var asset = assets[assetIndex];
        if (asset.type === ASSET_TYPE_VIDEO) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        className: className,
                        src: asset.src,
                        controls: isMain,
                        onPlay: function() {
                            return onVideoInteraction(asset, VIDEO_PLAY);
                        },
                        onEnded: function() {
                            return onVideoInteraction(asset, VIDEO_ENDED);
                        },
                        onPause: function() {
                            return onVideoInteraction(asset, VIDEO_PAUSE);
                        }
                    }),
                    !isMain && renderPlayIcon()
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            className: className,
            src: asset.src,
            alt: asset.title
        });
    }, [
        assets
    ]);
    var renderPreviewAssets = (0,react.useCallback)(function() {
        return assets.map(function(asset, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("preview-asset-wrapper", {
                    selected: index === selectedAssetIndex
                }),
                onClick: function() {
                    return selectAsset(index);
                },
                children: renderAssetIndex(index)
            }, index);
        });
    }, [
        assets,
        selectedAssetIndex,
        selectAsset,
        renderAssetIndex
    ]);
    var renderNewAssets = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "asset-gallery",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "main-asset-wrapper",
                    children: renderAssetIndex(selectedAssetIndex, true)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "assets-previews-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "previews-container",
                            ref: sideGalleryRef,
                            children: renderPreviewAssets()
                        }),
                        renderSideImagesOverlayIfNeeded()
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAssetGallery, {
        className: "asset-gallery",
        children: renderNewAssets()
    });
};
/* harmony default export */ var asset_gallery = (AssetGallery);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./static/svg/templates-store/benefit_icon.svg
var benefit_icon_path, _path2;
function benefit_icon_extends() {
    benefit_icon_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return benefit_icon_extends.apply(this, arguments);
}

var SvgBenefitIcon = function SvgBenefitIcon(props) {
    return /*#__PURE__*/ react.createElement("svg", benefit_icon_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), benefit_icon_path || (benefit_icon_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#676879",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m5 8.712 1.225 2.018q.07.122.182.194a.464.464 0 0 0 .48.017.55.55 0 0 0 .192-.182L11 5"
    })), _path2 || (_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#676879",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8"
    })));
};
/* harmony default export */ var benefit_icon = (SvgBenefitIcon);

;// CONCATENATED MODULE: ./template-store/components/template-benefits/benefit-component.scss.js

var StyledBenefit = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ecb44ec0"
})("display:flex;font-size:0.875rem;line-height:24px;&.align-center{flex-direction:column;align-items:center;.benefit-content{text-align:center;}.benefit-icon-wrapper{color:red;.benefit-icon{width:24px;height:24px;}}}.benefit-icon-wrapper{margin-top:2px;}.benefit-content{flex-grow:1;margin-left:8px;.benefit-title{font-weight:700;}.benefit-description{}}");

;// CONCATENATED MODULE: ./template-store/components/template-benefits/benefit-component.js




var Benefit = function(param) {
    var title = param.title, description = param.description, alignToCenter = param.alignToCenter;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBenefit, {
        className: classnames_default()("benefit-component", {
            "align-center": alignToCenter
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "benefit-icon-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefit_icon, {
                    className: "benefit-icon"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "benefit-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "benefit-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "benefit-description",
                        children: description
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var benefit_component = (Benefit);

;// CONCATENATED MODULE: ./template-store/components/template-benefits/template-benefits.scss.js


var StyledTemplateBenefits = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1688kmq0"
})("color:", colors/* default.mud */.Z.mud, ";display:flex;flex-direction:column;&.align-center{align-items:center;.template-benefits-main-title{text-align:center;}}.template-benefits-main-title{font-weight:700;font-size:1rem;line-height:24px;}.template-benefit-wrapper{margin-top:32px;}");

;// CONCATENATED MODULE: ./template-store/components/template-benefits/template-benefits.js
function template_benefits_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            template_benefits_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var TemplateBenefits = function(param) {
    var benefits = param.benefits, alignToCenter = param.alignToCenter, translate = param.translate;
    if (!benefits || benefits.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTemplateBenefits, {
        className: classnames_default()("template-benefits", {
            "align-center": alignToCenter
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "template-benefits-main-title",
                children: translate("templateCenter.benefits.title")
            }),
            benefits.map(function(benefit, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "template-benefit-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefit_component, _object_spread_props(_object_spread({}, benefit), {
                        alignToCenter: alignToCenter
                    }), "benefit_".concat(index))
                });
            })
        ]
    });
};
TemplateBenefits.propTypes = {
    alignToCenter: (prop_types_default()).bool,
    benefits: prop_types_default().arrayOf(prop_types_default().shape({
        title: (prop_types_default()).string,
        description: (prop_types_default()).string
    }))
};
TemplateBenefits.defaultProps = {
    alignToCenter: false,
    benefits: []
};
/* harmony default export */ var template_benefits = ((0,generic_config_context/* withGenericConfig */.P)(TemplateBenefits));

;// CONCATENATED MODULE: ./template-store/components/template-long-description/template-long-description.scss.js


var StyledTemplateLongDescription = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e9vczzt0"
})("color:", colors/* default.mud */.Z.mud, ";display:flex;flex-direction:column;.template-description-main-title{font-weight:700;font-size:1rem;line-height:24px;}.template-paragraph-wrapper{font-size:0.875rem;margin-top:16px;max-width:720px;line-height:24px;}.template-description-read-more{font-size:0.875rem;align-self:flex-start;margin:16px 0;color:", colors/* default.dodger-blue */.Z["dodger-blue"], ";cursor:pointer;text-decoration:underline;&:hover{filter:brightness(85%);}}");

;// CONCATENATED MODULE: ./template-store/components/template-long-description/template-long-description.js





var TemplateLongDescription = function(param) {
    var descriptions = param.descriptions, translate = param.translate;
    var ref = (0,react.useState)(false), readMore = ref[0], setReadMore = ref[1];
    if (!descriptions || descriptions.length === 0) return null;
    var firstParagraph = descriptions[0];
    var restParagraphs = descriptions.slice(1);
    var handleReadMoreClick = function() {
        setReadMore(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTemplateLongDescription, {
        className: "template-long-description",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "template-description-main-title",
                children: translate("templateCenter.longDescription.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "template-paragraph-wrapper",
                children: firstParagraph === null || firstParagraph === void 0 ? void 0 : firstParagraph.paragraphContent
            }),
            !readMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "template-description-read-more",
                onClick: handleReadMoreClick,
                children: translate("templateCenter.longDescription.readMore")
            }),
            readMore && restParagraphs.length > 0 && restParagraphs.map(function(description, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "template-paragraph-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: description.paragraphContent
                    }, "description_".concat(index))
                });
            })
        ]
    });
};
TemplateLongDescription.propTypes = {
    descriptions: prop_types_default().arrayOf(prop_types_default().shape({
        paragraphContent: (prop_types_default()).string
    }))
};
TemplateLongDescription.defaultProps = {
    descriptions: []
};
/* harmony default export */ var template_long_description = ((0,generic_config_context/* withGenericConfig */.P)(TemplateLongDescription));

;// CONCATENATED MODULE: ./template-store/components/template-overview-content/template-overview-content.scss.js

var StyledTemplateOverviewContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ep4hd4s0"
})(".template-benefits-wrapper{margin-top:64px;max-width:632px;}.template-long-description-wrapper{.template-long-description-divider{margin:42px 0;border:0;border-top:2px solid #a2bbc155;width:100%;}}");

;// CONCATENATED MODULE: ./template-store/components/template-overview-content/template-overview-content.js






var TemplateOverviewContent = function(props) {
    var templateData = props.templateData;
    var images = templateData.images, videoLink = templateData.videoLink, longDescription = templateData.longDescription;
    var assetsList = (0,react.useMemo)(function() {
        var list = images.map(function(imageData) {
            return {
                src: imageData.url,
                title: imageData.title,
                type: ASSET_TYPE_IMAGE
            };
        });
        if (videoLink) {
            list.splice(1, 0, {
                src: videoLink,
                type: ASSET_TYPE_VIDEO
            }); //currently we always put the video as the 2nd item
        }
        return list;
    }, [
        images,
        videoLink
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTemplateOverviewContent, {
        className: "template-overview-content",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "images-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_gallery, {
                    assets: assetsList
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "template-benefits-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_benefits, {
                    benefits: templateData === null || templateData === void 0 ? void 0 : templateData.benefits
                })
            }),
            longDescription && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "template-long-description-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "template-long-description-divider"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_long_description, {
                        descriptions: longDescription
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var template_overview_content = (TemplateOverviewContent);

;// CONCATENATED MODULE: ./template-store/components/media-item/media-item-component.scss.js


var StyledMediaItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e150z1jl0"
})("display:flex;&.row{flex-direction:row;.media-item--icon-wrapper{width:48px;height:48px;margin-right:16px;margin-bottom:16px;.media-item--icon{width:100%;height:100%;}}}&.column{flex-direction:column;width:328px;.media-item--text{margin-top:8px;}.media-item--icon-wrapper{height:auto;width:100%;}}.media-item--icon-wrapper{border-radius:8px;}.media-item--text{color:", colors/* default.mud */.Z.mud, ";font-size:0.875rem;width:256px;line-height:22px;.media-item--title{font-weight:bold;}.media-item--subtitle{font-weight:300;}}");

;// CONCATENATED MODULE: ./template-store/components/media-item/media-item-component.js



var MediaItem = function(param) {
    var backgroundColor = param.backgroundColor, title = param.title, description = param.description, icon = param.icon, direction = param.direction;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMediaItem, {
        className: classnames_default()("media-item--wrapper", direction),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "media-item--icon-wrapper",
                style: {
                    backgroundColor: backgroundColor
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "media-item--icon",
                    src: icon,
                    alt: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "media-item--text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "media-item--title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "media-item--subtitle",
                        children: description
                    })
                ]
            })
        ]
    });
};
MediaItem.defaultProps = {};
/* harmony default export */ var media_item_component = (MediaItem);

;// CONCATENATED MODULE: ./template-store/components/items-list/items-list.component.scss.js

var StyledItemsList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "etjx40o0"
})("display:flex;flex-wrap:wrap;margin-bottom:-32px;justify-content:space-between;max-width:760px;.item-wrapper{margin-bottom:48px;}");

;// CONCATENATED MODULE: ./template-store/components/items-list/items-list-component.js
function items_list_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function items_list_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            items_list_component_define_property(target, key, source[key]);
        });
    }
    return target;
}




var ItemsList = function(param) {
    var items = param.items, direction = param.direction;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemsList, {
        className: "items-list-component",
        children: items.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "item-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(media_item_component, items_list_component_object_spread({
                    direction: direction
                }, item))
            }, "item_".concat(index));
        })
    });
};
ItemsList.defaultProps = {
    direction: "row"
};
/* harmony default export */ var items_list_component = ((0,generic_config_context/* withGenericConfig */.P)(ItemsList));

;// CONCATENATED MODULE: ./template-store/components/template-page-tabs/tabs/Columns.js




var COLUMN_COLORS = {
    button: "#514FC8",
    subtasks: colors/* default.light-blue */.Z["light-blue"],
    dependency: colors/* default.brand-iris */.Z["brand-iris"],
    dropdown: colors/* default.platform-red */.Z["platform-red"],
    integration: colors/* default.brand-turqoise */.Z["brand-turqoise"],
    "multiple-person": colors/* default.brand-turqoise */.Z["brand-turqoise"],
    email: colors/* default.brand-yellow */.Z["brand-yellow"],
    lookup: colors/* default.platform-red */.Z["platform-red"],
    "board-relation": colors/* default.platform-red */.Z["platform-red"],
    file: colors/* default.brand-turqoise */.Z["brand-turqoise"],
    hour: colors/* default.brand-yellow */.Z["brand-yellow"],
    formula: colors/* default.brand-iris */.Z["brand-iris"],
    text: colors/* default.light-blue */.Z["light-blue"],
    tag: colors/* default.purple */.Z.purple,
    person: colors/* default.brand-green */.Z["brand-green"],
    votes: colors/* default.brand-green */.Z["brand-green"],
    color: colors/* default.light-blue */.Z["light-blue"],
    rating: colors/* default.light-blue */.Z["light-blue"],
    numeric: colors/* default.brand-yellow */.Z["brand-yellow"],
    "color-picker": colors/* default.light-blue */.Z["light-blue"],
    timerange: colors/* default.purple */.Z.purple,
    date: colors/* default.brand-green */.Z["brand-green"],
    "pulse-log": colors/* default.brand-iris */.Z["brand-iris"],
    "pulse-updated": colors/* default.platform-red */.Z["platform-red"],
    timezone: "#514FC8",
    country: colors/* default.purple */.Z.purple,
    location: colors/* default.platform-red */.Z["platform-red"],
    "pulse-id": colors/* default.light-blue */.Z["light-blue"],
    link: colors/* default.light-blue */.Z["light-blue"],
    "columns-battery": colors/* default.purple */.Z.purple,
    week: colors/* default.brand-yellow */.Z["brand-yellow"],
    action: colors/* default.platform-red */.Z["platform-red"],
    "app-feature": "#666",
    autonumber: colors/* default.brand-yellow */.Z["brand-yellow"],
    group: colors/* default.brand-yellow */.Z["brand-yellow"],
    boolean: colors/* default.brand-yellow */.Z["brand-yellow"],
    "custom-url": colors/* default.brand-turqoise */.Z["brand-turqoise"],
    duration: colors/* default.brand-iris */.Z["brand-iris"],
    "long-text": colors/* default.brand-iris */.Z["brand-iris"],
    phone: colors/* default.brand-iris */.Z["brand-iris"],
    team: colors/* default.brand-turqoise */.Z["brand-turqoise"]
};
var ColumnsComponent = function(param) {
    var templateData = param.templateData, metadata = param.metadata;
    var columns = templateData.columns;
    var getcolumnMetadata = (0,react.useCallback)(function(column) {
        return metadata === null || metadata === void 0 ? void 0 : metadata.find(function(columnMetadata) {
            return columnMetadata.type === column;
        });
    }, [
        metadata
    ]);
    var columnsData = (0,react.useMemo)(function() {
        if (!columns) return;
        return columns.map(function(column) {
            var columnMetadata = getcolumnMetadata(column);
            if (!columnMetadata) return null;
            return {
                title: columnMetadata.title,
                description: columnMetadata.description,
                icon: columnMetadata.icon,
                backgroundColor: COLUMN_COLORS[columnMetadata.type] || colors/* default.brand-iris */.Z["brand-iris"]
            };
        });
    }, [
        getcolumnMetadata,
        columns
    ]);
    return columns ? /*#__PURE__*/ (0,jsx_runtime.jsx)(items_list_component, {
        items: columnsData
    }) : null;
};
/* harmony default export */ var Columns = (ColumnsComponent);

;// CONCATENATED MODULE: ./template-store/components/template-page-tabs/tabs/Views.js



var ViewsComponent = function(param) {
    var templateData = param.templateData, metadata = param.metadata;
    var views = templateData.views;
    var getViewsMetadata = (0,react.useCallback)(function(view) {
        return metadata === null || metadata === void 0 ? void 0 : metadata.find(function(viewMetadata) {
            return viewMetadata.type === view;
        });
    }, [
        metadata
    ]);
    var viewsData = (0,react.useMemo)(function() {
        if (!views) return;
        return views.map(function(view) {
            var viewMetadata = getViewsMetadata(view);
            if (!viewMetadata) return null;
            return {
                title: viewMetadata.title,
                description: viewMetadata.description,
                icon: "https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/template-store/views/".concat(view, ".svg")
            };
        });
    }, [
        getViewsMetadata,
        views
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(items_list_component, {
        items: viewsData,
        direction: "column"
    });
};
/* harmony default export */ var Views = (ViewsComponent);

;// CONCATENATED MODULE: ./template-store/components/template-page-tabs/tabs/Automations.scss.js

var StyledAutomationsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezy2kdx0"
})("max-width:720px;.automation-image{height:auto;width:100%;margin-bottom:16px;}");

;// CONCATENATED MODULE: ./template-store/components/template-page-tabs/tabs/Automations.js


var automations = [
    {
        src: "https://dapulse-res.cloudinary.com/image/upload/template_center/automations/automation1.png",
        description: "When due date arrives, notify item subscribers"
    },
    {
        src: "https://dapulse-res.cloudinary.com/image/upload/template_center/automations/automation2.png",
        description: "When priority changes to high, move item to group high priority"
    },
    {
        src: "https://dapulse-res.cloudinary.com/image/upload/template_center/automations/automation3.png",
        description: "When status changes to done, create an update"
    }
];
var AutomationsComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAutomationsComponent, {
        className: "automations-wrapper",
        children: automations.map(function(a) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "automation-image",
                src: a.src,
                alt: a.description
            });
        })
    });
};
/* harmony default export */ var Automations = (AutomationsComponent);

;// CONCATENATED MODULE: ./template-store/components/template-page-tabs/tabs/Integrations.js



var IntegrationsComponent = function(param) {
    var templateData = param.templateData, metadata = param.metadata, translate = param.translate;
    var integrations = templateData.integrations;
    var getIntegrationMetadata = (0,react.useCallback)(function(integration) {
        return metadata === null || metadata === void 0 ? void 0 : metadata.find(function(integrationMetadata) {
            return integrationMetadata.value === integration;
        });
    }, [
        metadata
    ]);
    var integrationsData = (0,react.useMemo)(function() {
        if (!integrations) return;
        return integrations.map(function(integration) {
            var integrationMetada = getIntegrationMetadata(integration);
            if (!integrationMetada) return null;
            return {
                title: integrationMetada.text,
                description: translate("templateCenter.integration.".concat(integration, ".description")),
                icon: integrationMetada.templateStoreUrl
            };
        });
    }, [
        getIntegrationMetadata,
        integrations,
        translate
    ]);
    return integrations ? /*#__PURE__*/ (0,jsx_runtime.jsx)(items_list_component, {
        items: integrationsData
    }) : null;
};
/* harmony default export */ var Integrations = (IntegrationsComponent);

;// CONCATENATED MODULE: ./template-store/components/template-page-tabs/tabs.js






var getTabsInfo = function(tabsMetadata) {
    return [
        {
            titleKey: "templateCenter.template.overview",
            component: template_overview_content
        },
        {
            titleKey: "templateCenter.template.columns",
            component: template_feature_content,
            featureTitleKey: "templateCenter.template.columns.title",
            featureDescriptionKey: "templateCenter.template.columns.description",
            //TODO: add video aria labels
            demoVideoFileName: "template_store_add_column.mp4",
            subsectionTitleKey: "templateCenter.template.columns.subsectionTitle",
            subsectionDescriptionKey: "templateCenter.template.columns.subsectionDescription",
            demoComponent: Columns,
            demoComponentMetadata: tabsMetadata === null || tabsMetadata === void 0 ? void 0 : tabsMetadata.columns,
            templateDataFieldName: "columns"
        },
        {
            titleKey: "templateCenter.template.views",
            component: template_feature_content,
            featureTitleKey: "templateCenter.template.views.title",
            featureDescriptionKey: "templateCenter.template.views.description",
            demoVideoFileName: "template_store_views.mp4",
            subsectionTitleKey: "templateCenter.template.views.subsectionTitle",
            subsectionDescriptionKey: "templateCenter.template.views.subsectionDescription",
            demoComponent: Views,
            demoComponentMetadata: tabsMetadata === null || tabsMetadata === void 0 ? void 0 : tabsMetadata.views,
            templateDataFieldName: "views"
        },
        {
            titleKey: "templateCenter.template.automations",
            component: template_feature_content,
            featureTitleKey: "templateCenter.template.automations.title",
            featureDescriptionKey: "templateCenter.template.automations.description",
            demoVideoFileName: "template_store_automations.mp4",
            subsectionTitleKey: "templateCenter.template.automations.subsectionTitle",
            subsectionDescriptionKey: "templateCenter.template.automations.subsectionDescription",
            demoComponent: Automations
        },
        {
            titleKey: "templateCenter.template.integrations",
            component: template_feature_content,
            featureTitleKey: "templateCenter.template.integrations.title",
            featureDescriptionKey: "templateCenter.template.integrations.description",
            demoVideoFileName: "template_store_integrations.mp4",
            subsectionTitleKey: "templateCenter.template.integrations.subsectionTitle",
            subsectionDescriptionKey: "templateCenter.template.integrations.subsectionDescription",
            demoComponent: Integrations,
            demoComponentMetadata: tabsMetadata === null || tabsMetadata === void 0 ? void 0 : tabsMetadata.integrations,
            templateDataFieldName: "integrations"
        }
    ];
};

;// CONCATENATED MODULE: ./template-store/components/template-page-tabs/template-page-tabs.scss.js

var StyledTemplatePageTabs = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e11zp9xf0"
})(".tabs-component.template-page-tabs-component{width:100%;max-width:990px;.tabs{justify-content:flex-start;.tab-component{min-width:0;flex-grow:1;.tab-label{color:#676879;}&:not(.active){.tab-label{font-weight:300;}}.tab-underline-placeholder{height:3px;}}}}");

;// CONCATENATED MODULE: ./template-store/components/template-page-tabs/template-page-tabs.js
function template_page_tabs_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function template_page_tabs_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            template_page_tabs_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var TemplatePageTabs = function(props) {
    var templateData = props.templateData, translate = props.translate, tabsMetadata = props.tabsMetadata;
    var renderTabs = (0,react.useMemo)(function() {
        return getTabsInfo(tabsMetadata).map(function(tabInfo) {
            var ContentComponent = tabInfo.component, moreTabContentProps = _object_without_properties(tabInfo, [
                "component"
            ]);
            var titleKey = moreTabContentProps.titleKey;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tab_component/* default */.Z, {
                label: translate(titleKey),
                labelTranslationKey: titleKey,
                useSmallLabels: true,
                color: "dodger-blue",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentComponent, template_page_tabs_object_spread({
                    templateData: templateData
                }, moreTabContentProps))
            }, titleKey);
        });
    }, [
        tabsMetadata,
        templateData,
        translate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTemplatePageTabs, {
        className: "template-page-tabs",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_component/* default */.Z, {
            autoTransition: false,
            role: "tabpanel",
            className: "template-page-tabs-component",
            tabsAlign: align_types.ALIGN_TYPES.LEFT,
            children: renderTabs
        })
    });
};
/* harmony default export */ var template_page_tabs = ((0,generic_config_context/* withGenericConfig */.P)(TemplatePageTabs));

;// CONCATENATED MODULE: ./template-store/components/template-page-content/desktop/desktop-template-page-content.scss.js

var StyledDesktopTemplatePageContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1cvzmmp0"
})("width:100%;.template-top-section-wrapper{display:flex;justify-content:space-between;}.template-field-wrapper{padding-bottom:8px;}.template-description-wrapper{margin-top:42px;max-width:720px;.template-description{font-size:0.875rem;line-height:150%;}}.template-page-tabs-wrapper{margin-top:42px;margin-bottom:64px;}");

;// CONCATENATED MODULE: ./template-store/components/template-page-content/desktop/desktop-template-page-content.js












var DesktopTemplatePageContent = function(props) {
    var template = props.template, templateId = props.templateId, translate = props.translate, allCategories = props.allCategories, tabsMetadata = props.tabsMetadata;
    var templateData = template === null || template === void 0 ? void 0 : template.data;
    var onUseTemplateClickAction = (0,react.useCallback)(function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SIGN_UP_WITH_TEMPLATE_CLICKED, {
            kind: templateId,
            info1: getSolutionEnglishName(template)
        });
    }, [
        template,
        templateId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDesktopTemplatePageContent, {
        className: "desktop-template-page-content-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "template-top-section-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_header, {
                            templateName: templateData === null || templateData === void 0 ? void 0 : templateData.name,
                            templateCategoriesData: getCategoriesData(allCategories, templateData === null || templateData === void 0 ? void 0 : templateData.categories),
                            categoriesPrefixText: translate("templateCenter.category.idealFor")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "button-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_button/* default */.Z, {
                            buttonText: translate("templateCenter.template.useTemplate"),
                            url: (0,links/* getPlatformAddSolutionLink */.pHh)(templateId),
                            isOpenLinkInNewTab: true,
                            onClick: onUseTemplateClickAction
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "template-description-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "template-description",
                    children: [
                        " ",
                        templateData === null || templateData === void 0 ? void 0 : templateData.description
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "template-page-tabs-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_page_tabs, {
                    templateData: templateData,
                    tabsMetadata: tabsMetadata
                })
            })
        ]
    });
};
DesktopTemplatePageContent.defaultProps = {};
/* harmony default export */ var desktop_template_page_content = ((0,generic_config_context/* withGenericConfig */.P)(DesktopTemplatePageContent));

// EXTERNAL MODULE: ./static/svg/arrow-left.svg
var arrow_left = __webpack_require__(61379);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./template-store/components/template-page-content/mobile/mobile-template-page-content.scss.js


var StyledMobileTemplatePageContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eu0l2zi0"
})("width:100%;margin-bottom:64px;padding:0 16px;position:relative;.template-center-link-wrapper{margin-top:16px;display:flex;align-items:center;.arrow-left{padding-right:4px;path{fill:", colors/* default.asphalt */.Z.asphalt, ";}}.template-center-link{text-decoration:none;color:", colors/* default.asphalt */.Z.asphalt, ";}}.template-top-section-wrapper{display:flex;justify-content:space-between;margin-top:24px;}.assets-carousel-wrapper{height:100%;margin-top:24px;.template-image-wrapper{height:100%;padding:4px 14px;background:", colors/* default.riverstone */.Z.riverstone, ";border-radius:1.5px;.template-image{width:100%;height:auto;}}.template-page-carousel{.slick-slider{.slick-list{.slick-track{padding:16px 0;}}}}}.template-field-wrapper{padding-bottom:8px;}.template-description-wrapper{margin-top:56px;.template-description{font-size:0.875rem;line-height:24px;}}.button-wrapper{position:fixed;height:80px;background:", colors/* default.white */.Z.white, ";display:flex;justify-content:center;align-items:center;width:100%;bottom:0;left:0;box-shadow:0px 4px 40px rgba(0,0,0,0.08);padding:0 32px;}.benefits-wrapper{margin-top:64px;}.long-description-wrapper{.template-long-description-divider{margin:48px auto;border:0;border-top:2px solid #a2bbc155;width:100%;}}");

;// CONCATENATED MODULE: ./template-store/components/template-page-content/mobile/mobile-template-page-content.js

















var MobileTemplatePageContent = function(props) {
    var template = props.template, templateId = props.templateId, translate = props.translate, allCategories = props.allCategories;
    var templateData = template === null || template === void 0 ? void 0 : template.data;
    var onUseTemplateClickAction = (0,react.useCallback)(function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SIGN_UP_WITH_TEMPLATE_CLICKED, {
            kind: templateId,
            info1: getSolutionEnglishName(template)
        });
    }, [
        template,
        templateId
    ]);
    var assets = templateData === null || templateData === void 0 ? void 0 : templateData.images;
    var assetRenderer = function(imageData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "template-image-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                className: "template-image",
                src: imageData === null || imageData === void 0 ? void 0 : imageData.url,
                alt: imageData === null || imageData === void 0 ? void 0 : imageData.title
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileTemplatePageContent, {
        className: "mobile-template-page-content-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "template-center-link-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_left/* default */.Z, {
                        className: "arrow-left"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: getSolutionsHomeLink(),
                        className: "template-center-link",
                        children: translate("templateCenter.template.templateCenterName")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "template-top-section-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "header-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_header, {
                        templateName: templateData === null || templateData === void 0 ? void 0 : templateData.name,
                        templateCategoriesData: getCategoriesData(allCategories, templateData === null || templateData === void 0 ? void 0 : templateData.categories),
                        categoriesPrefixText: translate("templateCenter.category.idealFor")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "assets-carousel-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, {
                    items: assets,
                    itemRenderer: assetRenderer,
                    slidesToShow: 1,
                    centerPadding: "16px",
                    autoplay: false,
                    dots: true,
                    carouselClassName: "template-page-carousel",
                    defaultIndex: 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "template-description-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "template-description",
                    children: [
                        " ",
                        templateData === null || templateData === void 0 ? void 0 : templateData.description
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "button-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_button/* default */.Z, {
                    buttonText: translate("templateCenter.template.useTemplate"),
                    url: (0,links/* getPlatformAddSolutionLink */.pHh)(templateId),
                    isOpenLinkInNewTab: true,
                    onClick: onUseTemplateClickAction,
                    buttonSize: "full"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "benefits-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_benefits, {
                    benefits: templateData === null || templateData === void 0 ? void 0 : templateData.benefits
                })
            }),
            (templateData === null || templateData === void 0 ? void 0 : templateData.longDescription) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "long-description-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "template-long-description-divider"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_long_description, {
                        descriptions: templateData.longDescription
                    })
                ]
            })
        ]
    });
};
MobileTemplatePageContent.defaultProps = {};
/* harmony default export */ var mobile_template_page_content = ((0,generic_config_context/* withGenericConfig */.P)(MobileTemplatePageContent));

;// CONCATENATED MODULE: ./template-store/components/template-page-content/template-page-content.scss.js


var StyledTemplatePageContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e19av5oo0"
})(".desktop-wrapper{display:block;}.mobile-wrapper{display:none;}@media (max-width:", vp_sizes/* TABLET_QUERY_MIN_WIDTH */.Al, "){.desktop-wrapper{display:none;}.mobile-wrapper{display:block;}}");

;// CONCATENATED MODULE: ./template-store/components/template-page-content/template-page-content.js
function template_page_content_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function template_page_content_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            template_page_content_define_property(target, key, source[key]);
        });
    }
    return target;
}




var TemplatePageContent = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTemplatePageContent, {
        className: "template-page-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "desktop-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_template_page_content, template_page_content_object_spread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_template_page_content, template_page_content_object_spread({}, props))
            })
        ]
    });
};
/* harmony default export */ var template_page_content = (TemplatePageContent);

;// CONCATENATED MODULE: ./template-store/components/template-list/cards-component/cards-component.scss.js

var BORDER_COLOR = "#e6e9ef";
var StyledCardsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erj9duo0"
})("display:flex;flex-direction:column;.title-wrapper{margin-bottom:32px;margin-top:24px;font-size:24px;font-weight:700;line-height:30px;}.cards-wrapper{display:flex;flex-wrap:wrap;gap:34px;}.card{text-decoration:none;color:inherit;border:0.5px solid;border-color:", BORDER_COLOR, ";border-radius:8px;display:flex;flex-direction:column;width:328px;margin-bottom:20px;.image-wrapper{.picture-component{img{max-width:100%;border-top-right-radius:8px;border-top-left-radius:8px;}}}.card-content{padding:16px 24px 24px 24px;.card-title{font-size:1.125rem;font-weight:700;margin-bottom:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}.card-description{font-size:0.875rem;font-weight:400;line-height:18px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;/* number of lines to show */\n        -webkit-box-orient:vertical;}}:hover{box-shadow:0px 8px 24px 0 rgba(0,0,0,0.16);}}.show-more{text-decoration:underline;color:blue;text-align:center;cursor:pointer;margin-top:32px;}");

;// CONCATENATED MODULE: ./template-store/components/template-list/cards-component/cards-component.js




var CardsComponent = function(param) {
    var cardItems = param.cardItems, showMoreText = param.showMoreText, showLessText = param.showLessText, title = param.title;
    var ref = (0,react.useState)(false), showAll = ref[0], setShowAll = ref[1];
    var toggleShowAll = function() {
        if (showAll) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        setShowAll(!showAll);
    };
    var renderCards = function() {
        var visibleSets = showAll ? cardItems : cardItems.slice(0, 9);
        return visibleSets.map(function(set, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                href: set.pageUrl,
                className: "card",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: set.thumbnailUrl
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "card-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "card-title",
                                children: set.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "card-description",
                                children: set.description
                            })
                        ]
                    })
                ]
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardsComponent, {
        className: "component-container",
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "title-wrapper",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cards-wrapper",
                children: renderCards()
            }),
            cardItems.length > 9 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "show-more",
                onClick: toggleShowAll,
                children: showAll ? showLessText : showMoreText
            })
        ]
    });
};
/* harmony default export */ var cards_component = (CardsComponent);

// EXTERNAL MODULE: ./node_modules/@mondaydotcomorg/monday-ui-components/dist/CardList.css
var CardList = __webpack_require__(35705);
;// CONCATENATED MODULE: ./template-store/components/template-list/template-list.scss.js



var StyledTemplateList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1sbeuux0"
})("@media (max-width:", vp_sizes/* TABLET_QUERY_MIN_WIDTH */.Al, "){.template-list-items{.card-list--component{margin:0;.title-wrapper{text-align:center;}.card-list-wrapper{justify-content:center;.card-item-component-wrapper{margin:0 8px 32px 8px;}}}}}");

;// CONCATENATED MODULE: ./template-store/components/template-list/template-list.js









var TemplateList = function(props) {
    var solutions = props.solutions, title = props.title, context = props.context, translate = props.translate;
    var onCardClicked = (0,react.useCallback)(function(solution) {
        var solutionId = getSolutionId(solution);
        var solutionEnglishName = getSolutionEnglishName(solution);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SOLUTION_CARD_CLICKED, {
            kind: solutionId,
            info1: solutionEnglishName,
            info2: context
        });
        window.location = getSolutionPageLink(solutionId, solutionEnglishName);
    }, [
        context
    ]);
    var cardsData = (0,react.useMemo)(function() {
        return solutions.map(function(solution) {
            var solutionId = getSolutionId(solution);
            var solutionEnglishName = getSolutionEnglishName(solution);
            return {
                thumbnailUrl: getSolutionThumbnail(solution.data),
                description: getSolutionShortDescription(solution.data),
                title: getSolutionName(solution.data),
                pageUrl: getSolutionPageLink(solutionId, solutionEnglishName),
                onClick: function() {
                    return onCardClicked(solution);
                }
            };
        });
    }, [
        onCardClicked,
        solutions
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTemplateList, {
        className: "template-list-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "template-list-items",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_component, {
                title: title,
                cardItems: cardsData,
                showMoreText: translate("templateCenter.cards.showMore"),
                showLessText: translate("templateCenter.cards.showLess")
            })
        })
    });
};
/* harmony default export */ var template_list = ((0,generic_config_context/* withGenericConfig */.P)(TemplateList));

;// CONCATENATED MODULE: ./template-store/components/banner/responsive-banner/responsive-banner.scss.js



var StyledResponsiveBanner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e67emio0"
})("height:240px;display:flex;background-color:", colors/* default.riverstone */.Z.riverstone, ";border-radius:8px;.content-wrapper{display:flex;flex-direction:column;justify-content:center;flex-grow:1;text-align:left;height:100%;padding-left:50px;.title{font-size:1.75rem;font-weight:700;line-height:38px;}.description{margin-top:12px;font-size:1rem;line-height:30px;}}.image-wrapper{height:100%;padding:0 72px;.banner-image{border-radius:0px 8px 8px 0px;height:100%;}}&.iris{background-color:", colors/* default.brand-iris */.Z["brand-iris"], ";color:white;}&.mobile-banner{flex-direction:column;height:initial;.content-wrapper{padding:24px 40px 0 40px;.title{font-size:1.125rem;line-height:24px;text-align:center;}.description{display:none;}}.image-wrapper{padding:0;display:flex;justify-content:center;.banner-image{width:100%;}}}@media (max-width:", vp_sizes/* MACBOOK_PRO_MAX_WIDTH */.Wh, "){&:not(.mobile-banner){.content-wrapper{padding-left:25px;}.image-wrapper{padding:0 16px;}}}");

;// CONCATENATED MODULE: ./template-store/components/banner/responsive-banner/responsive-banner.js



var ResponsiveBanner = function(props) {
    var title = props.title, description = props.description, imageLink = props.imageLink, TitleTag = props.titleTagComponent, DescriptionTag = props.descriptionTagComponent, color = props.color, isMobileBanner = props.isMobileBanner;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledResponsiveBanner, {
        className: classnames_default()("responsive-banner-component", color, {
            "mobile-banner": isMobileBanner
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleTag, {
                        className: "title",
                        children: [
                            " ",
                            title,
                            " "
                        ]
                    }),
                    !isMobileBanner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DescriptionTag, {
                        className: "description",
                        children: [
                            " ",
                            description
                        ]
                    })
                ]
            }),
            imageLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "banner-image",
                    src: imageLink
                })
            })
        ]
    });
};
/* harmony default export */ var responsive_banner = (ResponsiveBanner);
ResponsiveBanner.defaultProps = {
    titleTagComponent: "div",
    descriptionTagComponent: "div",
    color: "iris",
    isMobileBanner: false // not using isMobileOrTablet since we want this behaviour in every screen under 768px
};

;// CONCATENATED MODULE: ./template-store/components/banner/banner.scss.js


var StyledBanner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq7n3a00"
})(".desktop-wrapper{display:block;}.mobile-wrapper{display:none;}@media (max-width:", vp_sizes/* TABLET_QUERY_MIN_WIDTH */.Al, "){.desktop-wrapper{display:none;}.mobile-wrapper{display:block;}}");

;// CONCATENATED MODULE: ./template-store/components/banner/banner.js
function banner_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function banner_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            banner_define_property(target, key, source[key]);
        });
    }
    return target;
}



var DESKTOP_BANNER_PLACEHOLDER_LINK = "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/mondayhomepage/template-store/banners-images/main_banner_image-no-padding.png";
var MOBILE_BANNER_PLACEHOLDER_LINK = "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/mondayhomepage/template-store/banners-images/mobile_banner.png";
var Banner = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBanner, {
        className: "banner-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "desktop-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(responsive_banner, banner_object_spread({
                    imageLink: DESKTOP_BANNER_PLACEHOLDER_LINK
                }, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(responsive_banner, banner_object_spread({
                    isMobileBanner: true,
                    imageLink: MOBILE_BANNER_PLACEHOLDER_LINK
                }, props))
            })
        ]
    });
};
/* harmony default export */ var banner = (Banner);

// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./template-store/components/mobile-navigation/costume-select/custom-select.scss.js




var COSTUME_SELECT_BACKGROUND_COLOR = "#dff0ff";
var COSTUME_SELECT_BORDER_COLOR = "#1e90ff";
var COSTUME_SELECT_OPTIONS_BORDER_COLOR = "#ccc";
var COSTUME_SELECT_TEXT_COLOR = "#0085ff";
var StyledCustomSelect = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1xyjfh0"
})("position:relative;width:100%;margin:auto;.custom-select-selection{padding:12px 12px 12px 16px;background-color:", COSTUME_SELECT_BACKGROUND_COLOR, ";cursor:pointer;display:flex;justify-content:space-between;align-items:center;height:42px;border-radius:2px;.down-arrow{display:flex;align-items:center;.picture-component{display:flex;align-items:center;img{height:14px;width:14px;}}}.label{display:flex;align-items:center;gap:8px;}&.with-border{outline:1px solid ", COSTUME_SELECT_BORDER_COLOR, ";}}.custom-select-options{position:absolute;width:100%;background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";border:1px solid ", COSTUME_SELECT_OPTIONS_BORDER_COLOR, ";margin-top:8px;padding-left:0;max-height:300px;overflow:auto;z-index:", z_index/* TOP_LAYER */.nA, ";box-shadow:0 0 0 1px rgba(0,0,0,0.1);.custom-select-option{list-style:none;padding:8px 8px 8px 20px;cursor:pointer;text-align:left;&.is-selected{background-color:", COSTUME_SELECT_BACKGROUND_COLOR, ";color:", COSTUME_SELECT_TEXT_COLOR, ";}a{text-decoration:none;color:inherit;display:flex;align-items:center;gap:8px;}}}");

;// CONCATENATED MODULE: ./template-store/components/mobile-navigation/costume-select/custom-select.js








var HOME_OPTION_VALUE = "home";
var HOME_OPTION_URL_VALUE = "/templates";
var FEATURED_TITLE = "Featured";
var DOWN_ARROW_ICON = "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/chevron-down-template-center-v2.png";
var CustomSelect = function(param) {
    var _options = param.options, options = _options === void 0 ? [] : _options;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(null), selectedOption = ref1[0], setSelectedOption = ref1[1];
    var ref2 = (0,react.useState)(false), isWithBorder = ref2[0], setIsWithBorder = ref2[1];
    var selectRef = (0,react.useRef)(null); // Reference to the select element
    var selectedOptionRef = (0,react.useRef)(null); // Reference to the selected option element
    var toggleOpen = function() {
        if (!isOpen) {
            setIsWithBorder(true);
        }
        setIsOpen(!isOpen);
    };
    (0,react.useEffect)(function() {
        var onPopUpClose = function() {
            if (isOpen) {
                setIsOpen(false);
            }
        };
        var checkIfClickedOutside = function(e) {
            if (selectedOptionRef.current && !selectedOptionRef.current.contains(e.target)) {
                onPopUpClose();
                setIsWithBorder(false);
            }
        };
        document.addEventListener("click", checkIfClickedOutside);
        return function() {
            document.removeEventListener("click", checkIfClickedOutside);
        };
    }, [
        isOpen
    ]);
    (0,react.useEffect)(function() {
        // Get the last word from the current URL
        var lastWordFromURL = (0,url.getLastPartOfUrl)(window.location.pathname);
        // Check if the last word exists
        if (lastWordFromURL) {
            setSelectedOption(lastWordFromURL);
        }
    }, []);
    var getLabelByValue = function(value) {
        var item = options.find(function(item) {
            return item.value === value;
        });
        return item ? item.label : null;
    };
    // Function to scroll the selected option into view
    var scrollToSelected = function() {
        if (!selectRef.current || !isOpen) return;
        var selectedItem = selectRef.current.querySelector('.custom-select-option[data-value="'.concat(selectedOption, '"]'));
        if (selectedItem) {
            var selectedItemRect = selectedItem.getBoundingClientRect();
            var selectRect = selectRef.current.getBoundingClientRect();
            // Calculate the scroll offset needed to bring the item into view
            var scrollTop = selectedItemRect.top - selectRect.top - 100;
            // Ensure the scroll position doesn't go negative
            selectRef.current.scrollTop = Math.max(0, scrollTop);
        }
    };
    (0,react.useEffect)(function() {
        if (isOpen) {
            scrollToSelected();
        }
    }, [
        isOpen,
        selectedOption
    ]); // Update scroll on open/close and selection change
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCustomSelect, {
        className: "custom-select-container",
        ref: selectedOptionRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("custom-select-selection", {
                    "with-border": isWithBorder
                }),
                tabIndex: 0,
                onClick: toggleOpen,
                ref: selectRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "label",
                        children: [
                            selectedOption === HOME_OPTION_URL_VALUE && /*#__PURE__*/ (0,jsx_runtime.jsx)((Favorite_default()), {}),
                            getLabelByValue(selectedOption) || FEATURED_TITLE
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "down-arrow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: DOWN_ARROW_ICON
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "custom-select-options",
                ref: selectRef,
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: classnames_default()("custom-select-option", {
                            "is-selected": selectedOption === option.value || selectedOption === HOME_OPTION_URL_VALUE && option.value === HOME_OPTION_VALUE
                        }),
                        "data-value": option.value,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: getSolutionCategoryPageLink(option.value),
                            children: [
                                option.value === HOME_OPTION_VALUE && /*#__PURE__*/ (0,jsx_runtime.jsx)((Favorite_default()), {}),
                                option.label
                            ]
                        })
                    }, option.value);
                })
            })
        ]
    });
};
/* harmony default export */ var custom_select = (CustomSelect);

;// CONCATENATED MODULE: ./template-store/components/mobile-navigation/mobile-navigation-component.scss.js

var StyledMobileTemplatesNavigation = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1aq9hos0"
})("width:100%;.mobile-search-wrapper{margin-top:8px;}");

;// CONCATENATED MODULE: ./template-store/components/mobile-navigation/mobile-navigation-component.js














var mobile_navigation_component_Search = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3044).then(__webpack_require__.t.bind(__webpack_require__, 23044, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23044)
            ];
        }
    },
    ssr: false
});
var MobileTemplatesNavigation = function(props) {
    var allCategories = props.allCategories, translate = props.translate, selectedCategoryId = props.selectedCategoryId, onSearchChange = props.onSearchChange, searchTerm = props.searchTerm, showSearch = props.showSearch, focusOnSearch = props.focusOnSearch;
    var categoryOptions = (0,react.useMemo)(function() {
        var categories = allCategories.map(function(categoryData) {
            var categoryId = getCategoryId(categoryData);
            var categoryName = getCategoryName(categoryData);
            return {
                value: categoryId,
                label: categoryName
            };
        });
        categories.unshift({
            value: constants_categories.HOME_ID,
            label: translate("templateCenter.template.featured"),
            iconComponent: (Favorite_default())
        });
        return categories;
    }, [
        allCategories,
        translate
    ]);
    var selectedOption = (0,react.useMemo)(function() {
        return categoryOptions.find(function(option) {
            return option.value === selectedCategoryId;
        });
    }, [
        categoryOptions,
        selectedCategoryId
    ]);
    var chooseCategory = (0,react.useCallback)(function(option) {
        if (!(option === null || option === void 0 ? void 0 : option.value) || (option === null || option === void 0 ? void 0 : option.value) === selectedCategoryId) return;
        var link = getSolutionCategoryPageLink(option.value);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.MENU_CATEGORY_CLICKED, {
            kind: option.value
        });
        window.location = link;
    }, [
        selectedCategoryId
    ]);
    var onSearchBlur = (0,react.useCallback)(function(e) {
        var _e_target;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SOLUTION_STORE_SEARCH_COMPLETED, {
            kind: e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileTemplatesNavigation, {
        className: "mobile-navigation-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-category-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_select, {
                    className: "category-dropdown",
                    value: selectedOption,
                    classNamePrefix: "select",
                    isClearable: false,
                    isSearchable: false,
                    name: "category",
                    options: categoryOptions,
                    onChange: chooseCategory
                })
            }),
            showSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-search-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_navigation_component_Search, {
                    placeholder: translate("templateCenter.template.search"),
                    onChange: onSearchChange,
                    value: searchTerm,
                    iconName: (Search_default()),
                    secondaryIconName: (CloseSmall_default()),
                    onBlur: onSearchBlur,
                    autoFocus: focusOnSearch
                })
            })
        ]
    });
};
MobileTemplatesNavigation.defaultProps = {
    showSearch: false
};
/* harmony default export */ var mobile_navigation_component = ((0,generic_config_context/* withGenericConfig */.P)(MobileTemplatesNavigation));

;// CONCATENATED MODULE: ./template-store/components/category-page-content/category-page-content.scss.js


var StyledCategoryPageContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "en7zrwb0"
})(".template-list-wrapper{margin:52px 0 100px 0;}.mobile-navigation-wrapper{display:none;}@media (max-width:", vp_sizes/* TABLET_QUERY_MIN_WIDTH */.Al, "){.mobile-navigation-wrapper{display:flex;width:100%;margin-top:24px;}}");

;// CONCATENATED MODULE: ./template-store/components/category-page-content/category-page-content.js








var CategoryPageContent = function(props) {
    var solutions = props.solutions, categoryData = props.categoryData, translate = props.translate, allCategories = props.allCategories;
    var bannerTitle = (0,react.useMemo)(function() {
        return translate(getBannerTitleKeyForCategory(categoryData === null || categoryData === void 0 ? void 0 : categoryData.value));
    }, [
        categoryData
    ]);
    var bannerDescription = (0,react.useMemo)(function() {
        return translate(getBannerDescriptionKeyForCategory(categoryData === null || categoryData === void 0 ? void 0 : categoryData.value));
    }, [
        categoryData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCategoryPageContent, {
        className: "category-page-content-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "banner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(banner, {
                    title: bannerTitle,
                    description: bannerDescription,
                    titleTagComponent: "h1",
                    descriptionTagComponent: "h3"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-navigation-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_navigation_component, {
                    allCategories: allCategories,
                    selectedCategoryId: categoryData === null || categoryData === void 0 ? void 0 : categoryData.value
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "template-list-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_list, {
                    solutions: solutions,
                    context: categoryData === null || categoryData === void 0 ? void 0 : categoryData.value
                })
            })
        ]
    });
};
/* harmony default export */ var category_page_content = ((0,generic_config_context/* withGenericConfig */.P)(CategoryPageContent));

;// CONCATENATED MODULE: ./static/svg/templates-store/design_icon.svg
var design_icon_path, design_icon_path2, _path3, _path4, _path5;
function design_icon_extends() {
    design_icon_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return design_icon_extends.apply(this, arguments);
}

var SvgDesignIcon = function SvgDesignIcon(props) {
    return /*#__PURE__*/ react.createElement("svg", design_icon_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 75,
        height: 67,
        fill: "none",
        viewBox: "0 0 75 67"
    }, props), design_icon_path || (design_icon_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 3,
        d: "M6.725 65a4.67 4.67 0 0 1-3.341-1.42A4.9 4.9 0 0 1 2 60.155V7.218a5.3 5.3 0 0 1 1.495-3.685A5.04 5.04 0 0 1 7.087 2h60.726a5.01 5.01 0 0 1 3.575 1.525 5.28 5.28 0 0 1 1.487 3.667v52.59a5.3 5.3 0 0 1-1.495 3.685A5.04 5.04 0 0 1 67.788 65zM72.875 17.75H2"
    })), design_icon_path2 || (design_icon_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M9 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M16.278 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M23.555 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    })), _path3 || (_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 3,
        d: "M18.956 25H11v31.825h7.956zM11.86 32.135h6.872M11.86 40.726h6.872M11.86 49.317h6.872"
    })), _path4 || (_path4 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 3,
        d: "M47.933 43.585h3.978l3.15 2.652h8.784v10.608H47.933z"
    })), _path5 || (_path5 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 3,
        d: "M33.044 40.772 52.2 29.936M54.52 31.304a2.652 2.652 0 1 0 0-5.304 2.652 2.652 0 0 0 0 5.304M30.652 44.564a2.652 2.652 0 1 0 0-5.304 2.652 2.652 0 0 0 0 5.304"
    })));
};
/* harmony default export */ var design_icon = (SvgDesignIcon);

;// CONCATENATED MODULE: ./static/svg/templates-store/sales_and_crm_icon.svg
var sales_and_crm_icon_path, sales_and_crm_icon_path2, sales_and_crm_icon_path3;
function sales_and_crm_icon_extends() {
    sales_and_crm_icon_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return sales_and_crm_icon_extends.apply(this, arguments);
}

var SvgSalesAndCrmIcon = function SvgSalesAndCrmIcon(props) {
    return /*#__PURE__*/ react.createElement("svg", sales_and_crm_icon_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 70,
        height: 70,
        fill: "none",
        viewBox: "0 0 70 70"
    }, props), sales_and_crm_icon_path || (sales_and_crm_icon_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 3,
        d: "M12.313 51.5H10.25A8.25 8.25 0 0 1 2 43.25V35a8.25 8.25 0 0 1 8.25-8.25h2.063a2.06 2.06 0 0 1 2.062 2.063v20.625a2.06 2.06 0 0 1-2.062 2.062M59.75 51.5h-2.062a2.06 2.06 0 0 1-2.063-2.062V28.812a2.06 2.06 0 0 1 2.063-2.062h2.062A8.25 8.25 0 0 1 68 35v8.25a8.25 8.25 0 0 1-8.25 8.25"
    })), sales_and_crm_icon_path2 || (sales_and_crm_icon_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 3,
        d: "M10.25 26.75A24.75 24.75 0 0 1 35 2v0a24.75 24.75 0 0 1 24.75 24.75M43.25 63.875h7.071c2.501 0 4.9-1.043 6.667-2.9 1.769-1.856 2.762-4.374 2.762-7V51.5"
    })), sales_and_crm_icon_path3 || (sales_and_crm_icon_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 3,
        d: "M39.125 68H35a4.125 4.125 0 0 1 0-8.25h4.125a4.125 4.125 0 0 1 0 8.25"
    })));
};
/* harmony default export */ var sales_and_crm_icon = (SvgSalesAndCrmIcon);

;// CONCATENATED MODULE: ./static/svg/templates-store/software_development_icon.svg
var software_development_icon_path, software_development_icon_path2, software_development_icon_path3;
function software_development_icon_extends() {
    software_development_icon_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return software_development_icon_extends.apply(this, arguments);
}

var SvgSoftwareDevelopmentIcon = function SvgSoftwareDevelopmentIcon(props) {
    return /*#__PURE__*/ react.createElement("svg", software_development_icon_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 75,
        height: 67,
        fill: "none",
        viewBox: "0 0 75 67"
    }, props), software_development_icon_path || (software_development_icon_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 3,
        d: "M6.725 65a4.67 4.67 0 0 1-3.341-1.42A4.9 4.9 0 0 1 2 60.155V7.218a5.3 5.3 0 0 1 1.495-3.685A5.04 5.04 0 0 1 7.087 2h60.726a5.01 5.01 0 0 1 3.575 1.525 5.28 5.28 0 0 1 1.487 3.667v52.59a5.3 5.3 0 0 1-1.495 3.685A5.04 5.04 0 0 1 67.788 65zM72.875 17.75H2"
    })), software_development_icon_path2 || (software_development_icon_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M9 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M16.278 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M23.555 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    })), software_development_icon_path3 || (software_development_icon_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 3,
        d: "m51.612 31.077 9.45 9.692-9.45 9.693M23.264 31.077l-9.45 9.692 9.45 9.693M42.163 31.077l-9.45 19.385"
    })));
};
/* harmony default export */ var software_development_icon = (SvgSoftwareDevelopmentIcon);

;// CONCATENATED MODULE: ./static/svg/templates-store/project_management_icon.svg
var project_management_icon_path, project_management_icon_path2;
function project_management_icon_extends() {
    project_management_icon_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return project_management_icon_extends.apply(this, arguments);
}

var SvgProjectManagementIcon = function SvgProjectManagementIcon(props) {
    return /*#__PURE__*/ react.createElement("svg", project_management_icon_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 75,
        height: 67,
        fill: "none",
        viewBox: "0 0 75 67"
    }, props), project_management_icon_path || (project_management_icon_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 3,
        d: "M6.725 65a4.67 4.67 0 0 1-3.341-1.42A4.9 4.9 0 0 1 2 60.155V7.218a5.3 5.3 0 0 1 1.495-3.685A5.04 5.04 0 0 1 7.087 2h60.726a5.01 5.01 0 0 1 3.575 1.525 5.28 5.28 0 0 1 1.487 3.667v52.59a5.3 5.3 0 0 1-1.495 3.685A5.04 5.04 0 0 1 67.788 65z"
    })), project_management_icon_path2 || (project_management_icon_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 3,
        d: "M38.733 10.533h-25.6A2.133 2.133 0 0 0 11 12.667v25.6c0 1.178.955 2.133 2.133 2.133h25.6a2.133 2.133 0 0 0 2.134-2.133v-25.6a2.133 2.133 0 0 0-2.134-2.134M61.5 49h-15c-1.38 0-2.5.895-2.5 2v4c0 1.105 1.12 2 2.5 2h15c1.38 0 2.5-.895 2.5-2v-4c0-1.105-1.12-2-2.5-2M13.133 57.467h8.534M13.133 48.933h12.8M11.626 11.159l28.615 28.615M40.241 11.159 11.626 39.774M63.067 38.267v-25.6M55 38.6V13"
    })));
};
/* harmony default export */ var project_management_icon = (SvgProjectManagementIcon);

;// CONCATENATED MODULE: ./static/svg/templates-store/hr_icon.svg
var hr_icon_path;
function hr_icon_extends() {
    hr_icon_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return hr_icon_extends.apply(this, arguments);
}

var SvgHrIcon = function SvgHrIcon(props) {
    return /*#__PURE__*/ react.createElement("svg", hr_icon_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 73,
        height: 73,
        fill: "none",
        viewBox: "0 0 73 73"
    }, props), hr_icon_path || (hr_icon_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 3,
        d: "M54.893 2A16.021 16.021 0 0 0 42.82 28.643l-2.015 11.59 10.496-6.473A16.086 16.086 0 1 0 54.892 2M20.398 50.293c5.715 0 10.348-4.633 10.348-10.348s-4.633-10.349-10.348-10.349-10.349 4.633-10.349 10.349c0 5.715 4.633 10.348 10.349 10.348M38.795 70.99A18.563 18.563 0 0 0 2 70.99"
    })));
};
/* harmony default export */ var hr_icon = (SvgHrIcon);

;// CONCATENATED MODULE: ./static/svg/templates-store/marketing_icon.svg
var marketing_icon_path, marketing_icon_path2, marketing_icon_path3;
function marketing_icon_extends() {
    marketing_icon_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return marketing_icon_extends.apply(this, arguments);
}

var SvgMarketingIcon = function SvgMarketingIcon(props) {
    return /*#__PURE__*/ react.createElement("svg", marketing_icon_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 74,
        height: 74,
        fill: "none",
        viewBox: "0 0 74 74"
    }, props), marketing_icon_path || (marketing_icon_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 3,
        d: "m8.455 38.706 1.415-3.579-3.304-8.358a2.74 2.74 0 0 1-.047-1.88 2.85 2.85 0 0 1 1.184-1.492l7.764-4.889 2.423-8.632a2.83 2.83 0 0 1 1.107-1.548 3 3 0 0 1 1.868-.536l9.261.454 7.221-5.62A3 3 0 0 1 39.187 2a3 3 0 0 1 1.84.626l7.22 5.62 9.262-.445a3 3 0 0 1 1.868.536c.542.38.932.925 1.107 1.548l2.423 8.632 7.764 4.89c.56.352.978.878 1.185 1.492.207.613.19 1.276-.048 1.879l-3.3 8.358 3.3 8.356c.238.603.255 1.266.048 1.88a2.85 2.85 0 0 1-1.185 1.495l-7.764 4.873-2.435 8.636a2.83 2.83 0 0 1-1.106 1.55 3 3 0 0 1-1.87.536l-9.261-.445-7.22 5.608M2 63.25 6.375 72"
    })), marketing_icon_path2 || (marketing_icon_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 3,
        d: "M50.125 54.739 5.235 67.625 2 62.949 31.8 28.25z"
    })), marketing_icon_path3 || (marketing_icon_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 3,
        d: "m17.313 65.438 1.06 3.035a7.4 7.4 0 0 0 2.09 2.176c.842.58 1.797.985 2.805 1.192a7.8 7.8 0 0 0 3.062.014 7.7 7.7 0 0 0 2.817-1.168 8.12 8.12 0 0 0 3.326-5.06c.405-2.038.057-3.761-1.086-5.514"
    })));
};
/* harmony default export */ var marketing_icon = (SvgMarketingIcon);

// EXTERNAL MODULE: ./node_modules/@mondaydotcomorg/monday-ui-components/dist/TilesList.js
var TilesList = __webpack_require__(14454);
var TilesList_default = /*#__PURE__*/__webpack_require__.n(TilesList);
// EXTERNAL MODULE: ./node_modules/@mondaydotcomorg/monday-ui-components/dist/TilesList.css
var dist_TilesList = __webpack_require__(4894);
;// CONCATENATED MODULE: ./template-store/components/categories-tiles/categories-tiles-component.scss.js



var StyledCategoryIdToTileMapping = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e17jqen80"
})("@media (max-width:", vp_sizes/* TABLET_QUERY_MIN_WIDTH */.Al, "){.tiles-list--wrapper{text-align:center;.tile-items--container{margin-top:16px;margin-right:-12px;justify-content:center;.tile-item--container{margin:6px 12px;.tile-item--wrapper{margin-top:8px;width:calc(100vw / 2 - 40px);.tile-item--background{height:52px;svg{height:32px;}}.tile-item--label{margin-top:8px;font-size:0.6875rem;}}}}}}");

;// CONCATENATED MODULE: ./template-store/components/categories-tiles/categories-tiles-component.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function categories_tiles_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function categories_tiles_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function categories_tiles_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        categories_tiles_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
















var categoryIdToTileMapping = function(category) {
    var categoryId = getCategoryId(category);
    var _obj;
    var tile = (_obj = {}, (0,_define_property/* default */.Z)(_obj, (categories_default()).MARKETING, {
        background: colors/* default.brand-red */.Z["brand-red"],
        iconRenderer: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(marketing_icon, {});
        }
    }), (0,_define_property/* default */.Z)(_obj, (categories_default()).PROJECT_MANAGEMENT, {
        background: colors/* default.brand-yellow */.Z["brand-yellow"],
        iconRenderer: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(project_management_icon, {});
        }
    }), (0,_define_property/* default */.Z)(_obj, (categories_default()).CRM, {
        background: colors/* default.brand-green */.Z["brand-green"],
        iconRenderer: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(sales_and_crm_icon, {});
        }
    }), (0,_define_property/* default */.Z)(_obj, (categories_default()).DESIGN, {
        background: colors/* default.brand-blue */.Z["brand-blue"],
        iconRenderer: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_icon, {});
        }
    }), (0,_define_property/* default */.Z)(_obj, (categories_default()).SOFTWARE_DEVELOPMENT, {
        background: colors/* default.brand-purple */.Z["brand-purple"],
        iconRenderer: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(software_development_icon, {});
        }
    }), (0,_define_property/* default */.Z)(_obj, (categories_default()).HR, {
        background: colors/* default.brand-turqoise */.Z["brand-turqoise"],
        iconRenderer: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(hr_icon, {});
        }
    }), _obj)[categoryId];
    return categories_tiles_component_object_spread_props(categories_tiles_component_object_spread({
        categoryId: categoryId
    }, category, tile), {
        link: getSolutionCategoryPageLink(categoryId),
        onClick: function() {
            return (0,bigbrain_service.trackEvent)(bigbrain_event_types.FEATURED_CATEGORY_CLICKED, {
                kind: categoryId
            });
        }
    });
};
var CategoriesTiles = function(param) {
    var title = param.title, categories = param.categories;
    var categoriesTiles = (0,react.useMemo)(function() {
        return categories.map(function(category) {
            return categoryIdToTileMapping(category);
        });
    }, [
        categories
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCategoryIdToTileMapping, {
        className: "category-tiles-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((TilesList_default()), {
            tiles: categoriesTiles,
            title: title
        })
    });
};
/* harmony default export */ var categories_tiles_component = (CategoriesTiles);

;// CONCATENATED MODULE: ./template-store/services/solutions-service.js


var CATEGORIES_TO_REMOVE = [
    (categories_default()).FEATURED_TEMPLATES
];
var solutionExists = function(allSolutions, solutionId) {
    return !!getSolutionData(allSolutions, solutionId);
};
var getSolution = function(allSolutions, solutionId) {
    var solution = allSolutions.find(function(sol) {
        return getSolutionId(sol).toString() === solutionId;
    });
    return solution;
};
var getSolutionData = function(allSolutions, solutionId) {
    var solution = getSolution(allSolutions, solutionId);
    return solution === null || solution === void 0 ? void 0 : solution.data;
};
var categoryExists = function(allCategories, categoryId) {
    return !!allCategories.find(function(category) {
        return (category === null || category === void 0 ? void 0 : category.value) === categoryId;
    });
};
var filterCategories = function(allCategories, allSolutions) {
    // filter out categories which have only templates and unwanted categories
    return allCategories.filter(function(category) {
        return doesCategoryContainSolutions(allSolutions, category === null || category === void 0 ? void 0 : category.value) && !CATEGORIES_TO_REMOVE.includes(category === null || category === void 0 ? void 0 : category.value);
    });
};
var getSolutionsInCategory = function(allSolutions, categoryId) {
    var solutionsInCategory = allSolutions.filter(function(solution) {
        var _solution_data_categories;
        return (_solution_data_categories = solution.data.categories) === null || _solution_data_categories === void 0 ? void 0 : _solution_data_categories.includes(categoryId);
    });
    var topTemplates = solutionsInCategory.filter(function(solution) {
        return solution.data.isTopTemplate;
    }); //sort runs in different order in browser and node resulting in server client inconsistancy
    var nonTopTemplates = solutionsInCategory.filter(function(solution) {
        return !solution.data.isTopTemplate;
    });
    return topTemplates.concat(nonTopTemplates);
};
var doesCategoryContainSolutions = function(allSolutions, categoryId) {
    return !!allSolutions.find(function(solution) {
        var _solution_data_categories;
        return (_solution_data_categories = solution.data.categories) === null || _solution_data_categories === void 0 ? void 0 : _solution_data_categories.includes(categoryId);
    });
};
var doesSolutionMatchSearchTerm = function(solutionData, searchTerm) {
    var solutionName = getSolutionName(solutionData); // Will add more search options in the near future
    if (!solutionName || !searchTerm) return false;
    return solutionName.toLowerCase().includes(searchTerm.toLowerCase());
};
var filterSolutions = function(allSolutions, searchTerm) {
    return allSolutions.filter(function(solution) {
        return doesSolutionMatchSearchTerm(solution.data, searchTerm);
    });
};
var getMostPopularSolutions = function(allSolutions) {
    return allSolutions.filter(function(solution) {
        return solution.data.isMostPopular;
    });
};
var getNewAndNotableSolutions = function(allSolutions) {
    return allSolutions.filter(function(solution) {
        return solution.data.isNewAndNotable;
    });
};

// EXTERNAL MODULE: ./template-store/constants/template-list-context.js
var template_list_context = __webpack_require__(46638);
;// CONCATENATED MODULE: ./template-store/components/template-homepage-content/template-homepage-content.scss.js


var StyledTemplateHomePageContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1dzgciu0"
})(".mobile-navigation-wrapper{display:none;}.featured-categories-wrapper{margin-top:52px;}.most-popular-wrapper{margin-top:52px;}.new-and-notable-wrapper{margin-bottom:100px;}@media (max-width:", vp_sizes/* TABLET_QUERY_MIN_WIDTH */.Al, "){.mobile-navigation-wrapper{display:flex;width:100%;margin-top:24px;}.featured-categories-wrapper{margin-top:32px;}.most-popular-wrapper{margin-top:72px;}}");

;// CONCATENATED MODULE: ./template-store/components/template-homepage-content/template-homepage-content.js











var TemplateHomePageContent = function(props) {
    var translate = props.translate, allSolutions = props.allSolutions, allCategories = props.allCategories, onSearchChange = props.onSearchChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTemplateHomePageContent, {
        className: "template-home-page-content-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "banner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(banner, {
                    title: translate("templateCenter.homepage.bannerTitle"),
                    description: translate("templateCenter.homepage.bannerDescription"),
                    titleTagComponent: "h1",
                    descriptionTagComponent: "h2"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-navigation-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_navigation_component, {
                    allCategories: allCategories,
                    selectedCategoryId: constants_categories.HOME_ID,
                    showSearch: "true",
                    onSearchChange: onSearchChange
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "featured-categories-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(categories_tiles_component, {
                    categories: getFeaturedCategories(allCategories),
                    title: translate("templateCenter.homepage.featuredCategories")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "most-popular-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_list, {
                    solutions: getMostPopularSolutions(allSolutions),
                    title: translate("templateCenter.homepage.mostPopular"),
                    context: template_list_context.MOST_POPULAR_CONTEXT
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "new-and-notable-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_list, {
                    solutions: getNewAndNotableSolutions(allSolutions),
                    title: translate("templateCenter.homepage.newAndNotable"),
                    context: template_list_context.NEW_AND_NOTEABLE_CONTEXT
                })
            })
        ]
    });
};
/* harmony default export */ var template_homepage_content = ((0,generic_config_context/* withGenericConfig */.P)(TemplateHomePageContent));

;// CONCATENATED MODULE: ./template-store/components/search-page-content/search-page-content.scss.js


var StyledSearchPageContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "el6yzvw0"
})(".banner-wrapper{display:none;}.mobile-navigation-wrapper{display:none;}@media (max-width:", vp_sizes/* TABLET_QUERY_MIN_WIDTH */.Al, "){.banner-wrapper{display:block;}.template-list-wrapper{margin-top:36px;}.mobile-navigation-wrapper{display:flex;width:100%;margin-top:24px;}}");

;// CONCATENATED MODULE: ./template-store/components/search-page-content/search-page-content.js








var SearchPageContent = function(props) {
    var allCategories = props.allCategories, filteredSolutions = props.filteredSolutions, translate = props.translate, translateWithParam = props.translateWithParam, searchTerm = props.searchTerm, onSearchChange = props.onSearchChange;
    var title = translateWithParam("templateCenter.search.resultsTitle", filteredSolutions.length);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSearchPageContent, {
        className: "search-page-content-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "banner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(banner, {
                    title: translate("templateCenter.homepage.bannerTitle"),
                    description: translate("templateCenter.homepage.bannerDescription"),
                    titleTagComponent: "h1",
                    descriptionTagComponent: "h3"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-navigation-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_navigation_component, {
                    allCategories: allCategories,
                    selectedCategoryId: constants_categories.HOME_ID,
                    showSearch: "true",
                    onSearchChange: onSearchChange,
                    searchTerm: searchTerm,
                    focusOnSearch: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "template-list-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_list, {
                    title: "".concat(title, ' "').concat(searchTerm, '"'),
                    solutions: filteredSolutions,
                    context: template_list_context.SEARCH_CONTEXT
                })
            })
        ]
    });
};
/* harmony default export */ var search_page_content = ((0,generic_config_context/* withGenericConfig */.P)(SearchPageContent));

;// CONCATENATED MODULE: ./template-store/components/main-page-content/main-page-content.js










var MainPageContent = function(props) {
    var pageType = props.pageType, allSolutions = props.allSolutions, allCategories = props.allCategories, categoryId = props.categoryId, solutionId = props.solutionId, searchTerm = props.searchTerm, filteredSolutions = props.filteredSolutions, tabsMetadata = props.tabsMetadata, onSearchChange = props.onSearchChange;
    var pageContent = (0,react.useMemo)(function() {
        switch(pageType){
            case solution_page_types.SINGLE_SOLUTION_PAGE_TYPE:
                var solution = getSolution(allSolutions, solutionId);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(template_page_content, {
                    templateId: solutionId,
                    template: solution,
                    allCategories: allCategories,
                    tabsMetadata: tabsMetadata
                });
            case solution_page_types.SOLUTIONS_IN_CATEGORY_PAGE_TYPE:
                var solutionsToShow = getSolutionsInCategory(allSolutions, categoryId);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(category_page_content, {
                    solutions: solutionsToShow,
                    categoryData: getCategoryData(allCategories, categoryId),
                    allCategories: allCategories
                });
            case solution_page_types.SOLUTIONS_HOME_PAGE_TYPE:
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(template_homepage_content, {
                    allSolutions: allSolutions,
                    allCategories: allCategories,
                    onSearchChange: onSearchChange
                });
        }
    }, [
        pageType,
        allSolutions,
        solutionId,
        allCategories,
        categoryId,
        tabsMetadata,
        onSearchChange
    ]);
    var searchResults = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(search_page_content, {
            searchTerm: searchTerm,
            filteredSolutions: filteredSolutions,
            allCategories: allCategories,
            onSearchChange: onSearchChange,
            categoryData: getCategoryData(allCategories, categoryId)
        });
    }, [
        allCategories,
        categoryId,
        filteredSolutions,
        onSearchChange,
        searchTerm
    ]);
    return searchTerm ? searchResults : pageContent;
};
/* harmony default export */ var main_page_content = ((0,generic_config_context/* withGenericConfig */.P)(MainPageContent));

// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./components/pages/solutions/solution-page-layout-component.scss.js



var STICKY_TOP_PX = "".concat(constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT + 24, "px");
var StyledSolutionPageLayoutComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eg2mmf60"
})(".template-page-content{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;margin-top:72px;padding:0 32px;display:flex;.desktop-navigation-wrapper{min-width:320px;padding-right:92px;margin-bottom:48px;.navigation-sticky-wrapper{position:-webkit-sticky;/* Safari */\n        position:sticky;top:", STICKY_TOP_PX, ";}}.page-main-content{width:100%;flex-grow:1;}}@media (max-width:", vp_sizes/* MACBOOK_PRO_MAX_WIDTH */.Wh, "){.template-page-content{.desktop-navigation-wrapper{min-width:260px;padding-right:16px;}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MIN_WIDTH */.Al, "){.template-page-content{max-width:100vw;padding:0 16px;margin-top:8px;.desktop-navigation-wrapper{display:none;}}}");

;// CONCATENATED MODULE: ./components/pages/solutions/solution-page-layout-component.js
function solution_page_layout_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function solution_page_layout_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            solution_page_layout_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function solution_page_layout_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function solution_page_layout_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        solution_page_layout_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function solution_page_layout_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = solution_page_layout_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function solution_page_layout_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}















var SEARCH_TERM_MIN_LENGTH_FOR_BIGBRAIN_EVENT = 3;
var SolutionPageLayoutComponent = function(props) {
    var pageType = props.pageType, allSolutions = props.allSolutions, allCategories = props.allCategories, categoryId = props.categoryId, solutionId = props.solutionId, searchTermFromAdressBar = props.searchTermFromAdressBar, tabsMetadata = props.tabsMetadata, baseTemplateProps = solution_page_layout_component_object_without_properties(props, [
        "pageType",
        "allSolutions",
        "allCategories",
        "categoryId",
        "solutionId",
        "searchTermFromAdressBar",
        "tabsMetadata"
    ]);
    var ref = (0,react.useState)(""), searchTerm = ref[0], setsearchTerm = ref[1];
    var ref1 = (0,react.useState)([]), filteredSolutions = ref1[0], setFilteredSolutions = ref1[1];
    var handleSearchTermChange = (0,react.useCallback)(function(term) {
        var solutions = filterSolutions(allSolutions, term);
        setsearchTerm(term);
        setFilteredSolutions(solutions);
        if (term.length >= SEARCH_TERM_MIN_LENGTH_FOR_BIGBRAIN_EVENT) (0,bigbrain_service.trackEvent)(bigbrain_event_types.SOLUTION_STORE_SEARCH, {
            kind: term,
            info1: solutions === null || solutions === void 0 ? void 0 : solutions.length
        });
        history.replaceState({}, "", getSolutionSearchLink(term));
    }, [
        allSolutions
    ]);
    (0,react.useEffect)(function() {
        if (searchTermFromAdressBar) {
            handleSearchTermChange(searchTermFromAdressBar);
        }
    }, []);
    var selectedCategoryId = (0,react.useMemo)(function() {
        if (pageType === solution_page_types.SOLUTIONS_IN_CATEGORY_PAGE_TYPE) return categoryId;
        if (pageType === solution_page_types.SOLUTIONS_HOME_PAGE_TYPE) return constants_categories.HOME_ID;
        return null;
    }, [
        categoryId,
        pageType
    ]);
    var pageMetaTitle = (0,react.useMemo)(function() {
        switch(pageType){
            case solution_page_types.SOLUTIONS_IN_CATEGORY_PAGE_TYPE:
                return "templateCenter.".concat(categoryId, ".meta.title");
            case solution_page_types.SINGLE_SOLUTION_PAGE_TYPE:
                var solution = getSolution(allSolutions, solutionId);
                var solutionName = getSolutionName(solution);
                return {
                    key: "templateCenter.specificTemplate.meta.title",
                    param: solutionName
                };
            default:
                return "templateCenter.meta.title";
        }
    }, [
        categoryId,
        solutionId,
        pageType,
        allSolutions
    ]);
    var canonicalUrl = (0,react.useMemo)(function() {
        if (pageType !== solution_page_types.SINGLE_SOLUTION_PAGE_TYPE) return null;
        if (SOLUTION_TO_CANONICAL_URL_MAPPING[solutionId]) {
            return SOLUTION_TO_CANONICAL_URL_MAPPING[solutionId];
        }
        var solution = getSolution(allSolutions, solutionId);
        var solutionEnglishName = getSolutionEnglishName(solution);
        return getSolutionPageLink(solutionId, solutionEnglishName);
    }, [
        allSolutions,
        pageType,
        solutionId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(base_template/* default */.Z, solution_page_layout_component_object_spread_props(solution_page_layout_component_object_spread({}, baseTemplateProps), {
        title: pageMetaTitle,
        description: "templateCenter.meta.description",
        enableHotjar: "true",
        canonicalUrl: canonicalUrl,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSolutionPageLayoutComponent, {
            className: "solution-page-component",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_component["default"], {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "template-page-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            className: "desktop-navigation-wrapper",
                            "aria-label": "Template categories",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "navigation-sticky-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_component, {
                                    onSearchChange: handleSearchTermChange,
                                    searchTerm: searchTerm,
                                    allCategories: allCategories,
                                    selectedCategoryId: selectedCategoryId
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            className: "page-main-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main_page_content, {
                                pageType: pageType,
                                allSolutions: allSolutions,
                                allCategories: allCategories,
                                categoryId: categoryId,
                                solutionId: solutionId,
                                searchTerm: searchTerm,
                                filteredSolutions: filteredSolutions,
                                tabsMetadata: tabsMetadata,
                                selectedCategoryId: selectedCategoryId,
                                onSearchChange: handleSearchTermChange
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_component["default"], {})
            ]
        })
    }));
};
/* harmony default export */ var solution_page_layout_component = (SolutionPageLayoutComponent);

// EXTERNAL MODULE: ./pages/generated-templates/base-template-page.js
var base_template_page = __webpack_require__(79813);
;// CONCATENATED MODULE: ./pages/homepage/solutions/solution-page.js




function solution_page_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function solution_page_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            solution_page_define_property(target, key, source[key]);
        });
    }
    return target;
}
function solution_page_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = solution_page_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function solution_page_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var SolutionPage = /*#__PURE__*/ function(BaseTemplatePage) {
    "use strict";
    (0,_inherits/* default */.Z)(SolutionPage, BaseTemplatePage);
    var _super = (0,_create_super/* default */.Z)(SolutionPage);
    function SolutionPage() {
        (0,_class_call_check/* default */.Z)(this, SolutionPage);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SolutionPage, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, statusCode = _this_props.statusCode, restProps = solution_page_object_without_properties(_this_props, [
                    "statusCode"
                ]);
                if (statusCode !== 200) return /*#__PURE__*/ (0,jsx_runtime.jsx)(error["default"], {
                    statusCode: statusCode
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(solution_page_layout_component, solution_page_object_spread({}, restProps));
            }
        }
    ]);
    return SolutionPage;
}(base_template_page["default"]);
var __N_SSP = true;



/***/ }),

/***/ 14285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ long_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./components/core/short-footer/short-footer.js + 4 modules
var short_footer = __webpack_require__(69861);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js + 1 modules
var footer_category_component = __webpack_require__(70212);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.scss.js
var long_footer_scss = __webpack_require__(17619);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js + 10 modules
var footer_bottom_bar_component = __webpack_require__(46374);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/long-footer.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}












var Footer = function(props) {
    var translate = props.translate, localeId = props.localeId, abTests = props.abTests, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig, setStartShowingStickyHeader = props.setStartShowingStickyHeader, isInView = props.isInView;
    (0,react.useEffect)(function() {
        setStartShowingStickyHeader(!isInView);
    }, [
        isInView,
        setStartShowingStickyHeader
    ]);
    var LONG_FOOTER = "long";
    var renderShortFooter = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer/* default */.Z, _object_spread({}, props));
    };
    var renderLongFooter = function() {
        var getFullFooterForLocalized = true;
        var footerComponents = (0,localization_service/* getFooterComponents */.L8)(localeId, abTests, getFullFooterForLocalized, {});
        if (pageClusterConfig) {
            (0,cluster_config_service/* updateClusterFooterLinks */.R4)(pageClusterConfig, footerComponents, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
        }
        var MondayFooterLinks = footerComponents.MondayFooterLinks, OurTeamFooterLinksV2 = footerComponents.OurTeamFooterLinksV2, MoreByMondayFooterLinks = footerComponents.MoreByMondayFooterLinks, UseCasesFooterLinksV2 = footerComponents.UseCasesFooterLinksV2, ResourcesFooterLinks = footerComponents.ResourcesFooterLinks, ProductsFooterLinks = footerComponents.ProductsFooterLinks, FeaturesFooterLinks = footerComponents.FeaturesFooterLinks;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(long_footer_scss/* StyledFooter */.tc, {
            className: "footer-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "categories-container",
                            children: [
                                MondayFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(MondayFooterLinks.title),
                                        links: MondayFooterLinks.links,
                                        hasMondayLogoTitle: MondayFooterLinks.hasMondayLogoTitle
                                    })
                                }),
                                FeaturesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container features",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(FeaturesFooterLinks.title),
                                        links: FeaturesFooterLinks.links
                                    })
                                }),
                                ProductsFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container products",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "categories-colmmn-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: ProductsFooterLinks.type,
                                                title: translate(ProductsFooterLinks.title),
                                                links: ProductsFooterLinks.links
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: MoreByMondayFooterLinks.type,
                                                title: translate(MoreByMondayFooterLinks.title),
                                                links: MoreByMondayFooterLinks.links
                                            })
                                        ]
                                    })
                                }),
                                UseCasesFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(UseCasesFooterLinksV2.title),
                                        links: UseCasesFooterLinksV2.links
                                    })
                                }),
                                OurTeamFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: OurTeamFooterLinksV2.type,
                                        title: translate(OurTeamFooterLinksV2.title),
                                        links: OurTeamFooterLinksV2.links
                                    })
                                }),
                                ResourcesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: ResourcesFooterLinks.type,
                                        title: translate(ResourcesFooterLinks.title),
                                        links: ResourcesFooterLinks.links
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_bar_component/* default */.Z, {
                    SocialFooterLinks: links/* SocialFooterLinks */.Ff7,
                    footerType: LONG_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledDesktopFooterContainer */.w2, {
                className: "footer-desktop-wrapper",
                children: renderLongFooter()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledMobileFooterContainer */.qJ, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
/* harmony default export */ var long_footer = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(Footer)));
Footer.defaultProps = default_props;


/***/ }),

/***/ 55408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LongFooterComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.js + 1 modules
var long_footer = __webpack_require__(14285);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.scss.js

var StyledLongFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1rc6ysx0"
})();

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var LongFooterComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LongFooterComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LongFooterComponent);
    function LongFooterComponent() {
        (0,_class_call_check/* default */.Z)(this, LongFooterComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(LongFooterComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLongFooterComponent, {
                    className: "long-footer-component",
                    id: element_ids/* FOOTER_ID */.D,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer/* default */.Z, _object_spread({}, this.props))
                });
            }
        }
    ]);
    return LongFooterComponent;
}(react.PureComponent);

LongFooterComponent.defaultProps = {};


/***/ }),

/***/ 24730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var Sentry = __webpack_require__(48491);
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var logException = (__webpack_require__(98989).logException);
var handleServerException = function() {
    var _ref = _async_to_generator(function(param) {
        var externalMessage, e, req, res, extraLogParams, _bbEventParams, bbEventParams;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    externalMessage = param.externalMessage, e = param.e, req = param.req, res = param.res, extraLogParams = param.extraLogParams, _bbEventParams = param.bbEventParams, bbEventParams = _bbEventParams === void 0 ? {} : _bbEventParams;
                    // 1. log to Coralogix
                    logException({
                        externalMessage: externalMessage,
                        e: e,
                        req: req,
                        res: res,
                        extraLogParams: extraLogParams
                    });
                    // 2. capture exception in Sentry
                    Sentry.captureException(e);
                    return [
                        4,
                        Sentry.flush(2000)
                    ];
                case 1:
                    _state.sent();
                    // 3. track server exception on BigBrain
                    return [
                        4,
                        trackBigBrainEventOnServer(bbEventParams.name || "server_exception", {
                            kind: bbEventParams.kind,
                            placement: req && req.url,
                            info1: e && e.message,
                            info2: req && req.params && req.params.id,
                            directObject: req && req.hostname
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function handleServerException(_) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    handleServerException: handleServerException
};


/***/ }),

/***/ 62494:
/***/ (function(module) {

"use strict";

module.exports = {
    MARKETING: "marketing",
    PROJECT_MANAGEMENT: "project_management",
    CRM: "sales_customers",
    SOFTWARE_DEVELOPMENT: "software_development",
    HR: "hr",
    DESIGN: "design",
    CONTENT_PRODUCTION: "content_production",
    FREELANCERS: "freelancers",
    OPERATIONS: "office_operations",
    STARTUP: "startup",
    EDUCATION: "education",
    REAL_ESTATE: "real_estate",
    CONSTRUCTION: "construction",
    HOME_ID: "home",
    FEATURED_TEMPLATES: "featured_templates"
};


/***/ }),

/***/ 46638:
/***/ (function(module) {

"use strict";

module.exports = {
    SEARCH_CONTEXT: "search",
    MOST_POPULAR_CONTEXT: "most_popular",
    NEW_AND_NOTEABLE_CONTEXT: "new_and_notable"
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7229,6602,390,8834,5365,4778,677,9359,3247,5657,932,4494,4961,1068,3211,9952,516,1360,4303,1373,3203,8885,1620,6227,3782,9774,2888,179], function() { return __webpack_exec__(74669); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);